// Auto-generated from Airtable Tasks export. Sorted by releaseDate ascending.
export const puzzles = [
  {
    "prompt": "🗽🔑🍟📆",
    "answers": "Freaky Friday; Freakie Friday; FreakyFriday",
    "hint1": "👩‍🦰🔁🧑‍🦰",
    "hint2": "🎸🥁🎤",
    "answerDescription": "An overworked mother and her daughter do not get along. When they switch bodies, each is forced to adapt to the other's life for one freaky Friday.",
    "category": "Movie",
    "rating": "6.3",
    "imageUrl": "https://allears.net/wp-content/uploads/2022/10/freaky-friday-movie.jpeg",
    "submittedBy": "Sammie",
    "releaseDate": "2022-12-05"
  },
  {
    "prompt": "👨‍👩‍👧‍👧🪤",
    "answers": "Parent Trap; The Parent Trap",
    "hint1": "🏕👑🚽",
    "hint2": "👩‍🦰👩‍🦰",
    "answerDescription": "A pair of twins separated at birth accidentally meet at summer camp and plot to bring their divorced parents back together.",
    "category": "Movie",
    "rating": "7.1",
    "imageUrl": "https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/300E2FE605731ED0F338D027EDB9FC2FD0384DCC98620AFFE5F3EDE7E58CAD87/scale?width=1200&aspectRatio=1.78&format=jpeg",
    "submittedBy": "Sammie",
    "releaseDate": "2022-12-06"
  },
  {
    "prompt": "🪨🔑",
    "answers": "Rocky",
    "hint1": "👁️🐅",
    "hint2": "🥊🥊",
    "answerDescription": "The film tells the rags-to-riches story of Rocky Balboa, an uneducated but kind-hearted working-class Italian-American boxer working as a debt collector in the slums of Philadelphia.",
    "category": "Movie",
    "rating": "8.1",
    "imageUrl": "https://cdn.posteritati.com/posters/000/000/036/785/rocky-md-web.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2022-12-07"
  },
  {
    "prompt": "🥧🐀🚗🍖🫘",
    "answers": "Pirates of the Caribbean; Pirates of the Carribbean; Pirates of the Carribean; The Pirates of the Caribbean; The Pirates of the Carribbean; The Pirates of the Carribean",
    "hint1": "💲🍐🚣🏻‍♀️",
    "hint2": "🏴‍☠️",
    "answerDescription": "A swashbuckling pirate must rescue the governor's daughter and confront the fearsome Captain Barbossa.",
    "category": "Movie",
    "rating": "8.1",
    "imageUrl": "https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/C6AB0EDCE8F41882EBBB782B76DD4F05D7E360D7C3F23B4F6D02C24699B26105/scale?width=1200&aspectRatio=1.78&format=jpeg",
    "submittedBy": "Aubrey",
    "releaseDate": "2022-12-08"
  },
  {
    "prompt": "🎣🙋🏻‍♂️↩️🥫",
    "answers": "Catch Me If You Can; Catch Me Id You Can",
    "hint1": "🐁🐁🪣🥛🧈",
    "hint2": "👨🏻‍✈️ 🕵🏻‍♂️",
    "answerDescription": "The true story of a young man who becomes a successful con artist and is eventually pursued by an FBI agent.",
    "category": "Movie",
    "rating": "8.1",
    "imageUrl": "https://thumbnails.cbsig.net/CBS_Production_Entertainment_VMS/2019/12/27/1663395907730/CATCH_SAlone_16_9_1920x1080_1224165_1920x1080.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2022-12-09"
  },
  {
    "prompt": "💵⚾",
    "answers": "Moneyball; Money Ball",
    "hint1": "📊🤓",
    "hint2": "Brad Pitt, Jonah Hill",
    "answerDescription": "Oakland A's general manager Billy Beane's successful attempt to assemble a baseball team on a lean budget by employing computer-generated analysis to acquire new players.",
    "category": "Movie",
    "rating": "7.6",
    "imageUrl": "https://occ.a.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABU_GaHooOpFjBBWVND5qwLXutpIgXecUywb9dtlJe4asrgLk5Lz4o9iEXLA-pdswxKnRQhKyVpWEfw8rm7nTAfr4HRn37N24Lvpy.jpg",
    "submittedBy": "Pryor",
    "releaseDate": "2022-12-10"
  },
  {
    "prompt": "🍇😡",
    "answers": "The Grapes of Wrath; Grapes of Wrath; Grapes of Rath",
    "hint1": "💨🥣",
    "hint2": "Written by John Steinbeck",
    "answerDescription": "The Joad family are forced to leave their Oklahoma farm and travel to California during the Dust Bowl of the 1930s.",
    "category": "Book",
    "rating": "",
    "imageUrl": "https://a.scpr.org/82531_69733b4ab19bfcdf8a0ef43b822e8986_original.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2022-12-11"
  },
  {
    "prompt": "🔇🐑🐑",
    "answers": "The Silence of the Lambs; Silence of the Lambs; Silence of the Lamb; The Silence of the Lamb",
    "hint1": "🦋👄",
    "hint2": "👋 Clarice",
    "answerDescription": "An FBI cadet must confide in an incarcerated and manipulative killer to receive help catching another serial killer who skins his victims.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://img3.hulu.com/user/v3/artwork/98db6119-0854-46cc-a338-b8d9f8a48a48?base_image_bucket_name=image_manager&base_image=d011abec-e906-463b-b4f9-22b13c0afa4b&region=US&format=jpeg&size=952x536",
    "submittedBy": "Aubrey",
    "releaseDate": "2022-12-12"
  },
  {
    "prompt": "🖋️🟥🐂🐂",
    "answers": "The Incredibles; Incredibles",
    "hint1": "🥶🏃🏿‍♂️💨",
    "hint2": "🦸‍♂️🦸‍♀️",
    "answerDescription": "A family of superheroes fights to restore the public's trust in superheroes while also dealing with their personal family issues.",
    "category": "Movie",
    "rating": "8.0",
    "imageUrl": "https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/AB48117EA822A2A545F91AA4DCA6B387B604B4FC592CFCB6760B9CF13377D30B/scale?width=1200&aspectRatio=1.78&format=jpeg",
    "submittedBy": "Sarah",
    "releaseDate": "2022-12-13"
  },
  {
    "prompt": "🇬🇧🦵🔱",
    "answers": "Britney Spears; Brittney Spears; Brittany Spears; Britnee Spears; Britny Spears; Britney Spear; Brittney Spear; Brittany Spear; Britnee Spear; Britny Spear",
    "hint1": "☣️🛢",
    "hint2": "🥊🙋‍♀️👶🔂🕰",
    "answerDescription": "American singer who rose to fame in the late 1990s and early 2000s with hits like \"Baby One More Time\" and \"Toxic.\"",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://cloudfront-eu-central-1.images.arcpublishing.com/thenational/VSWU3CCXPD2FL55V5Z5OGQQ57Q.jpg",
    "submittedBy": "Renee LaBarge",
    "releaseDate": "2022-12-14"
  },
  {
    "prompt": "🦉🫖🐡",
    "answers": "Hootie & the Blowfish; Hootie and the Blowfish; Hooty and the Blowfish; Hooty & the Blowfish; Hootie and the Blow Fish; Hooty and the Blow Fish; Hootie & the Blow Fish; Hooty & the Blow Fish",
    "hint1": "✉️😢",
    "hint2": "American rock band formed in Columbia, South Carolina, in 1986",
    "answerDescription": "Hootie & the Blowfish is an American rock band led by Darius Rucker. Their most popular songs are 'Only Wanna Be With You' and 'Let Her Cry'.",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://americansongwriter.com/wp-content/uploads/2022/08/Hootie-and-the-Blowfish-GettyImages-1209228243.jpg?fit=2000%2C800",
    "submittedBy": "\"B Sharp\"",
    "releaseDate": "2022-12-15"
  },
  {
    "prompt": "🚫🗾👨‍🦳👨‍🦳",
    "answers": "No Country for Old Men; No Country for Old Man",
    "hint1": "🤠🔫💊💰",
    "hint2": "Coen brothers",
    "answerDescription": "A man goes on the run after stumbling upon a drug deal gone wrong and is pursued by a relentless hitman.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://benjweinberg.files.wordpress.com/2018/08/nocountry.jpg?w=1200",
    "submittedBy": "Aubrey",
    "releaseDate": "2022-12-16"
  },
  {
    "prompt": "🔪🏃",
    "answers": "Blade Runner",
    "hint1": "🤖🔫",
    "hint2": "Directed by Ridley Scott",
    "answerDescription": "A science fiction film set in a dystopian future where genetically engineered robots called replicants are used as slave labor.",
    "category": "Movie",
    "rating": "8.2",
    "imageUrl": "https://www.wired.com/images_blogs/underwire/2012/05/BladeRunner.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2022-12-17"
  },
  {
    "prompt": "🧍‍♂️✂️👐",
    "answers": "Edward Scissorhands; Edward Scissorshands; Edward Scissor Hands; Edwerd Scissorhands",
    "hint1": "🌳🏠🌳🏠🌳",
    "hint2": "Directed by Tim Burton",
    "answerDescription": "A scientist builds an animated human being. The scientist dies before he can finish assembling Edward, though, leaving the young man with a freakish appearance.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/FD2777D8E9328B0795EECF64EE3E98D71AFD11AAA66C9E91237FD4B7AC6C701D/scale?width=1200&aspectRatio=1.78&format=jpeg",
    "submittedBy": "Aubrey",
    "releaseDate": "2022-12-18"
  },
  {
    "prompt": "🐻‍❄️❌📰",
    "answers": "The Polar Express; Polar Express; Poler Express; Polar Expres; The Polar Expres",
    "hint1": "🎅🏻",
    "hint2": "🎟🚂",
    "answerDescription": "A boy who doesn't believe in Santa Claus is given a magical train ride to the North Pole on Christmas Eve.",
    "category": "Movie",
    "rating": "6.6",
    "imageUrl": "https://aiptcomics.com/wp-content/uploads/2018/12/93QF3xkIueVbwrCuPp41dAd6CqT.jpg",
    "submittedBy": "Lis Threadgill",
    "releaseDate": "2022-12-19"
  },
  {
    "prompt": "⬜️🎅🏻",
    "answers": "White Claw; White Claws",
    "hint1": "🍋🍓🍒🥭",
    "hint2": "🥤",
    "answerDescription": "White Claw is a hard seltzer made with seltzer water, a blend of natural fruit flavors, and a hint of fruit juice.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://www.maxim.com/wp-content/uploads/2021/05/white-claw-promo-788x443.png",
    "submittedBy": "Aubrey",
    "releaseDate": "2022-12-20"
  },
  {
    "prompt": "🍽🎮",
    "answers": "The Hunger Games; Hunger Games; Hunger Game; The Hunger Game",
    "hint1": "🕊🔥",
    "hint2": "👩‍🦰🏹",
    "answerDescription": "In a dystopian future, children are forced to fight to the death in a televised event.",
    "category": "Book",
    "rating": "7.2",
    "imageUrl": "https://thefilmstage.com/wp-content/uploads/2010/11/Hungergames.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2022-12-21"
  },
  {
    "prompt": "🪡🐚🥅👷🏻‍♂️",
    "answers": "The Social Network; Social Network",
    "hint1": "💻",
    "hint2": "😀📘",
    "answerDescription": "The story of the founders of Facebook and the legal battles they faced as the company grew.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://media.npr.org/assets/img/2010/09/27/DF-07284r_wide-87fd7559255d81edd70eb22b68bc9f5b71f33e91-s1100-c50.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2022-12-22"
  },
  {
    "prompt": "🦘🪆🟥👃🏻🌧🦌",
    "answers": "Rudolph the Red-Nosed Reindeer; Rudolph the Red Nosed Reindeer; Rudolph the Red Nose Reindeer; Rudolf the Red Nosed Reindeer; Rudolph the Red Nose Raindeer; Rudolph the Red Nosed Raindeer",
    "hint1": "🛷",
    "hint2": "🎅🏻",
    "answerDescription": "A young reindeer struggles to fit in with his family and friends because of his glowing red nose.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://cloudfront-us-east-1.images.arcpublishing.com/advancelocal/ZLOTTU66NJDLVGJMMNGWQYXVGM.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2022-12-23"
  },
  {
    "prompt": "🍊📚",
    "answers": "Pulp Fiction",
    "hint1": "🤵🏿‍♂️🤵🏻‍♂️",
    "hint2": "Quentin Tarantino",
    "answerDescription": "A crime drama film about the intersecting lives of various underworld characters in Los Angeles.",
    "category": "Movie",
    "rating": "8.9",
    "imageUrl": "https://img.youtube.com/vi/tGpTpVyI_OQ/maxresdefault.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2022-12-24"
  },
  {
    "prompt": "🧙‍♂️🇦🇺",
    "answers": "The Wizard of Oz; Wizard of Oz",
    "hint1": "👠👠",
    "hint2": "🟨🧱🛣️",
    "answerDescription": "After a tornado rips through Kansas, Dorothy and her dog, Toto, are whisked away in their house to the magical land of Oz.",
    "category": "Movie",
    "rating": "8.1",
    "imageUrl": "https://hebdenbridgepicturehouse.co.uk/images/3015.jpg",
    "submittedBy": "Judy",
    "releaseDate": "2022-12-25"
  },
  {
    "prompt": "🥊♣️",
    "answers": "Fight Club; The Fight Club",
    "hint1": "🧼",
    "hint2": "Ed Norton",
    "answerDescription": "An insomniac office worker and a devil-may-care soapmaker form an underground fight club that evolves into something much, much more.",
    "category": "Movie",
    "rating": "8.8",
    "imageUrl": "https://www.svtstatic.se/image/custom/1024/33770618/1641300040?format=auto&chromaSubSampling=false&enableAvif=true",
    "submittedBy": "Aubrey",
    "releaseDate": "2022-12-26"
  },
  {
    "prompt": "⏮🦷🔢🪑",
    "answers": "Back to the Future",
    "hint1": "⚡️🏫",
    "hint2": "🚙🥼",
    "answerDescription": "A high school student is accidentally sent back in time to 1955 and must ensure that his parents fall in love in order to return to the present.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://streamcoimg-a.akamaihd.net/000/131/4538/1314538-Banner-L2-663d88fc928b13bc3676ca2906b22115.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2022-12-27"
  },
  {
    "prompt": "⛵️⛵️⛵️🪵💻",
    "answers": "Fleetwood Mac; Fleetwood Mack; Fleet Wood Mac; Fleet Wood Mack",
    "hint1": "⛓",
    "hint2": "🛬 🎚",
    "answerDescription": "A British-American rock band known for their distinctive vocal harmonies and eclectic mix of musical styles.",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://classicrockbob.files.wordpress.com/2013/01/color-shot.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2022-12-28"
  },
  {
    "prompt": "🍳📆🌃💡",
    "answers": "Friday Night Lights; Friday Night Lites; Friday Nite Lites; Friday night light",
    "hint1": "🇨🇱🏈",
    "hint2": "Featuring Tim McGraw",
    "answerDescription": "A drama about a high school football team in a small Texas town and the personal lives of the players and their families.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://cdn.vox-cdn.com/thumbor/MRnZo5D6498RafccQWXJBbVE7Lc=/0x0:972x1440/1200x800/filters:focal(391x862:545x1016)/cdn.vox-cdn.com/uploads/chorus_image/image/63924089/MV5BMTcxMDI5MTM4Ml5BMl5BanBnXkFtZTcwNjA4MDcyMQ__._V1_.0.jpg",
    "submittedBy": "Pryor",
    "releaseDate": "2022-12-29"
  },
  {
    "prompt": "👺👺🖋️",
    "answers": "Monsters Inc.; Monsters Ink; Monsters Inc; Monster Inc; Monster Ink",
    "hint1": "🚪",
    "hint2": "⬇️🛏",
    "answerDescription": "In a world where monsters scare children to generate energy, two monsters must team up to save a human child who has entered their world.",
    "category": "Movie",
    "rating": "8.1",
    "imageUrl": "https://m.media-amazon.com/images/M/MV5BMjE2MDU3MjI3Nl5BMl5BanBnXkFtZTcwODE2NDc3Mw@@._V1_.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2022-12-30"
  },
  {
    "prompt": "🐱🐕‍🦺🫖➕💔💔",
    "answers": "Tom Petty and the Heartbreakers; Tom Petty & the Heartbreakers; Tom Petty; Tom Pettie; Tom Pety",
    "hint1": "🏃🏻‍♂️⬇️😴💭",
    "hint2": "🇺🇸👧",
    "answerDescription": "An American rock band known for their hit songs \"Free Fallin'\" and \"American Girl.\"",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://townsquare.media/site/295/files/2015/05/Tom-Petty-Youre-Gonna-Get-It-Shelter-Records-Image.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2022-12-31"
  },
  {
    "prompt": "🛼🪨🪨",
    "answers": "The Rolling Stones; Rolling Stones",
    "hint1": "🟫🍭",
    "hint2": "🖌⚫️",
    "answerDescription": "An English rock band formed in London in 1962, known for their blues-infused rock and roll and iconic band members.",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://ichef.bbci.co.uk/images/ic/640x360/p09t527w.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-01"
  },
  {
    "prompt": "👔☀️👙🎅🏻",
    "answers": "Titanic; The Titanic",
    "hint1": "🌊🚪",
    "hint2": "🚢",
    "answerDescription": "A romantic drama about a poor artist who falls in love with a wealthy woman on the ill-fated voyage of the RMS Titanic.",
    "category": "Movie",
    "rating": "7.9",
    "imageUrl": "https://www.portablepress.com/wp-content/uploads/2015/12/Titanic-Movie.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-01-02"
  },
  {
    "prompt": "🩸💍",
    "answers": "Blood Diamond",
    "hint1": "🇸🇱",
    "hint2": "Leonardo DiCaprio",
    "answerDescription": "A fisherman, a smuggler, and a syndicate of businessmen match wits over the possession of a priceless diamond.",
    "category": "Movie",
    "rating": "8.0",
    "imageUrl": "https://hbomax-images.warnermediacdn.com/images/GXmbKrgEYfjC3wwEAACzs/tileburnedin?size=1280x720&partner=hbomaxcom&v=eaca183b464d505ed9c658e5dcc117b9&host=art-gallery.api.hbo.com&language=en-us&w=1280",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-03"
  },
  {
    "prompt": "🗻🫖🐍😇🏆",
    "answers": "Monty Python and the Holy Grail; Monty Python; Monty Python and the Holy Grale; Monty Python & the Holy Grail",
    "hint1": "🥥",
    "hint2": "🗡🛡",
    "answerDescription": "A comedic film about a group of knights who embark on a quest to find the Holy Grail, encountering absurd and fantastical obstacles along the way.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://dyn1.heritagestatic.com/lf?set=path%5B2%2F1%2F8%2F0%2F2%2F21802180%5D&call=url%5Bfile%3Aproduct.chain%5D",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-04"
  },
  {
    "prompt": "🎣👩🥃",
    "answers": "The Catcher in the Rye; Catcher in the Rye; Catcher in the Ry; Catcher Rye; Catcher in Rye; Catcher in the Rey; Catcher and the Rye; The Catcher and the Rye",
    "hint1": "📞🦵🦵",
    "hint2": "J.D. Salinger",
    "answerDescription": "A coming-of-age novel about a disillusioned teenager named Holden Caulfield who wanders around New York City after being kicked out of boarding school.",
    "category": "Book",
    "rating": "",
    "imageUrl": "https://i0.wp.com/www.raptisrarebooks.com/images/58531/the-catcher-in-the-rye-jd-salinger-first-edition-rare-signed.jpg?fit=1000%2C800&ssl=1",
    "submittedBy": "Sammie",
    "releaseDate": "2023-01-05"
  },
  {
    "prompt": "🐝🥱🗣",
    "answers": "Beyoncé; Beyonce",
    "hint1": "Song: 🤪🇳💘",
    "hint2": "Song: 😇",
    "answerDescription": "An American singer, songwriter, and actress known for her soulful voice and electrifying stage performances.",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://imgix.bustle.com/uploads/getty/2021/8/11/71937c82-77ab-401c-b2fa-fc532e2b5d54-getty-1277073965.jpg?w=800&fit=crop&crop=faces&auto=format%2Ccompress",
    "submittedBy": "Sammie",
    "releaseDate": "2023-01-06"
  },
  {
    "prompt": "🌎💨🔥",
    "answers": "Earth, Wind, and Fire; Earth, Wind, & Fire",
    "hint1": "September 21st",
    "hint2": "Disco band formed in Chicago in 1969",
    "answerDescription": "An American funk and soul band known for their horn-heavy sound and hits such as \"September\" and \"Boogie Wonderland.\"",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://cdn.vox-cdn.com/thumbor/2hfQOIFCPzzs8UwPQY8MZxy5zfs=/0x0:3200x1675/fit-in/1200x630/cdn.vox-cdn.com/uploads/chorus_asset/file/16323735/earth_wind_and_fire_getty_ringer.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-01-07"
  },
  {
    "prompt": "🦈👦🌋👧",
    "answers": "Adventures of Sharkboy & Lavagirl; The Adventures of Shark Boy and Lavagirl; Sharkboy & Lavagirl; Shark Boy and Lava Girl; The Adventures of Shark Boy and Lava Girl; Shark boy lava girl",
    "hint1": "🦸‍♂️🦸‍♀️",
    "hint2": "Taylor Lautner + Taylor Dooley",
    "answerDescription": "Two children with superpowers team up to save their dreams from an evil villain.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://img1.hulu.com/user/v3/artwork/f66caff2-0468-4617-b8b9-0a51185b1313?base_image_bucket_name=image_manager&base_image=12afaf37-5ab0-4c97-a89c-f026e83a4f87&region=US&format=jpeg&size=952x536",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-08"
  },
  {
    "prompt": "🧃🔟🐝🍺",
    "answers": "Justin Bieber; Justin Beeber",
    "hint1": "Song: 👶",
    "hint2": "Song: 🍑🇬🇪",
    "answerDescription": "A Canadian singer and songwriter known for his pop hits such as \"Baby\" and \"Sorry.\"",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://cdn-radio.dpgmedia.net/2/81/fa/ba/1477263/Justin_Justice.png",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-09"
  },
  {
    "prompt": "🐐😡ℹ️👨‍👩‍👦",
    "answers": "Billy Madison; Billie Madison; Billy Maddison",
    "hint1": "🔙2️⃣🧑‍🏫",
    "hint2": "Adam Sandler",
    "answerDescription": "A wealthy and immature man must repeat all of grade school to inherit his father's company.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "http://images1.resources.foxtel.com.au/store2/mount1/16/2/a82w3.jpg",
    "submittedBy": "Andrew Roche",
    "releaseDate": "2023-01-10"
  },
  {
    "prompt": "🎮🚽🚽",
    "answers": "Game of Thrones; The Game of Thrones; A Game of Thrones",
    "hint1": "🐉🧝‍♀️",
    "hint2": "🏰🐺⚔️",
    "answerDescription": "A fantasy drama series set in the fictional land of Westeros, where noble families fight for control of the Iron Throne.",
    "category": "TV Show",
    "rating": "",
    "imageUrl": "https://www.sbs.com.au/guide/sites/sbs.com.au.guide/files/styles/full/public/game_of_thrones_0.jpg?itok=mX68iavt",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-11"
  },
  {
    "prompt": "⚖️👱🏼‍♀️",
    "answers": "Legally Blonde; Legally Blond",
    "hint1": "Elle 🪵🪵",
    "hint2": "Reese Witherspoon",
    "answerDescription": "A comedy about a ditzy sorority girl who attends law school and proves to be a formidable opponent in the courtroom.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://ntvb.tmsimg.com/assets/p28004_v_h10_al.jpg?w=1280&h=720",
    "submittedBy": "Sammie",
    "releaseDate": "2023-01-12"
  },
  {
    "prompt": "🎖👅🅰️",
    "answers": "Metallica; Metalica",
    "hint1": "Song: 🚪⏳👨",
    "hint2": "Genre: heavy metal",
    "answerDescription": "An American heavy metal band known for their aggressive sound and hits such as \"Enter Sandman\" and \"Master of Puppets.\"",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://media.pitchfork.com/photos/5a21b59a6dd6a743aef5aa42/16:9/w_1280,c_limit/masterofpuppets.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-13"
  },
  {
    "prompt": "👨‍⚕️👽💘",
    "answers": "Dr. Strangelove; Dr. Strangelove or How I Learned to Stop Worrying and Love the Bomb; Doctor Strangelove; Doctor Strangelove or How I Learned to Stop Worrying and Love the Bomb",
    "hint1": "☢️💣",
    "hint2": "🇺🇸🇷🇺",
    "answerDescription": "The potential for global nuclear destruction is explored through the story of a mad general who plans to launch a nuclear attack on the Soviet Union.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://flixable.b-cdn.net/hbo-max/large/us/dr-strangelove-or-how-i-learned-to-stop-worrying-and-love-the-bomb.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-14"
  },
  {
    "prompt": "👋🏻🐂",
    "answers": "The Bible; Bible",
    "hint1": "⛪️",
    "hint2": "🧔🏻",
    "answerDescription": "A religious text containing the teachings and stories of the Judeo-Christian tradition.",
    "category": "Book",
    "rating": "",
    "imageUrl": "https://um-insight.net/downloads/313/download/Holy-Bible.jpg?cb=d7c66cda21ffa0b59262145100eec59f&w=1050",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-15"
  },
  {
    "prompt": "👁️➗2️⃣😴💭",
    "answers": "I Have A Dream; I Half A Dream; Have A Dream; I Have Dream; Eye Have a dream; Eye Half a Dream",
    "hint1": "Speech delivered in D.C. in 1963",
    "hint2": "Speaker's birthday is marked by a federal holiday each January",
    "answerDescription": "\"I have a dream that one day this nation will rise up and live out the true meaning of its creed: We hold these truths to be self-evident, that all men are created equal.\" -Martin Luther King Jr.",
    "category": "Quote",
    "rating": "",
    "imageUrl": "https://trumpwhitehouse.archives.gov/wp-content/uploads/2018/01/33870486865_c4be14daa8_o-1600x720.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-16"
  },
  {
    "prompt": "🦙👄⌚",
    "answers": "Apocalypse Now",
    "hint1": "🇻🇳🚁💣",
    "hint2": "Directed by Francis Ford Coppola",
    "answerDescription": "A U.S. Army captain is sent on a mission to kill a rogue colonel during the Vietnam War, but the journey upriver becomes a hallucinatory and existential journey for the captain.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://posterissim.com/1561/apocalypse-now.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-16"
  },
  {
    "prompt": "🤵🏻‍♂️🏟️📑🍠🍠",
    "answers": "Serena Williams",
    "hint1": "🎾",
    "hint2": "Sister: 🪐",
    "answerDescription": "Professional tennis player regarded as one of the greatest in the history of the sport, having won 23 Grand Slam singles titles.",
    "category": "Athlete",
    "rating": "",
    "imageUrl": "https://e0.365dm.com/22/06/2048x1152/skysports-serena-williams-wimbledon_5810223.jpg",
    "submittedBy": "Kinnon Walker",
    "releaseDate": "2023-01-17"
  },
  {
    "prompt": "🪀📖",
    "answers": "Toy Story",
    "hint1": "🤠",
    "hint2": "🧑🏻‍🚀♾️➕",
    "answerDescription": "A group of toys come to life and go on adventures when their owner is not around, but must band together when their owner's new toy threatens to replace them.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/26E7C634EB29C137475AE05AC983080BAE7E2E3741C49987EEA2539A40A9262C/scale?width=1200&aspectRatio=1.78&format=jpeg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-18"
  },
  {
    "prompt": "♾️🌞🐄<🧠",
    "answers": "Eternal Sunshine of the Spotless Mind; The Eternal Sunshine of the Spotless Mind",
    "hint1": "Jim Carrey",
    "hint2": "Kate Winslet",
    "answerDescription": "A couple undergo a procedure to erase their memories of each other after a painful breakup, but must confront the complexities of love and the power of memory.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://static.metacritic.com/images/products/movies/3/def728c4bd1b81d287399d11eb96dd12.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-19"
  },
  {
    "prompt": "🤷🚂🐉",
    "answers": "How to Train Your Dragon; Train Your Dragon; how to train a dragon",
    "hint1": "⚔️🛡️🪓🧔",
    "hint2": "DreamWorks (2010)",
    "answerDescription": "A young Viking learns to see beyond his tribe's longstanding hatred of dragons and befriends one, but must fight to protect his new friend from those who see dragons as enemies.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://occ-0-34-988.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABZB1zw-c6PGLhYunZbgDCAhIWC5VQ84bvbXaEX5ERgq7D9RQlDspaE8cxz4Dup_3I00yjf8rcPwPsIv4G_3OKNeE_U4Ih96irXme.jpg?r=548",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-20"
  },
  {
    "prompt": "🤿🐝💩",
    "answers": "Scooby Doo; Scoobie Doo; Scooby Do; Scoobie Do; Scoby Do; Scoby Doo; Scooby-Doo",
    "hint1": "Character: 🍪🐕",
    "hint2": "Means of Transportation: 🌫🌳📠",
    "answerDescription": "A group of teens and their dog solve mysteries involving supposedly supernatural creatures through comical and zany antics.",
    "category": "TV Show",
    "rating": "",
    "imageUrl": "https://hotcorn-cdn.s3.amazonaws.com/wp-content/uploads/sites/5/2019/02/14164337/Scooby-Doo-1-758x395.jpg",
    "submittedBy": "Renee LaBarge",
    "releaseDate": "2023-01-21"
  },
  {
    "prompt": "6️⃣👃👂👅👁️👉",
    "answers": "The Sixth Sense; Sixth Sense; The 6th Sense; 6th Sense",
    "hint1": "Quote: 👁️👀💀🧑‍🤝‍🧑",
    "hint2": "Actor: Bruce Willis",
    "answerDescription": "🤫🤫🤫",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://img1.hotstarext.com/image/upload/f_auto,t_hcdl/sources/r1/cms/prod/637/650637-h",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-22"
  },
  {
    "prompt": "🕰️👷‍♂️🍊",
    "answers": "A Clockwork Orange; A Clock Work Orange; Clockwork Orange; Clock Work Orange; the clockwork orange",
    "hint1": "Released in 1971",
    "hint2": "Director:  Stanley Kubrick",
    "answerDescription": "A sadistic gang leader is imprisoned and volunteers for a rehabilitation experiment, but it doesn't go as planned.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://ntvb.tmsimg.com/assets/p1587_v_h10_aa.jpg?w=1280&h=720",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-23"
  },
  {
    "prompt": "🤳🙋🏼🏡🪙🌳🛣🛣",
    "answers": "Take Me Home, Country Roads; Take Me Home, Country Road; Take Me Home Country Rode; Take Me Home Country Rode; Take Me Home Countrie Road; Country Road Take Me Home; Country Roads Take Me Home; Take Me Home Country Roads; Take Me Home Country Road; Country Roads",
    "hint1": "Lyric: 🏔🤱",
    "hint2": "Artist: John Denver",
    "answerDescription": "Written and performed by John Denver, this song reached No. 2 on the Billboard 100 in 1971.",
    "category": "Song",
    "rating": "",
    "imageUrl": "https://s3.amazonaws.com/mountainlake.org/wp-content/uploads/2020/11/18143852/John-devner-country-roads.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-01-24"
  },
  {
    "prompt": "🥻🔪🟥Ⓜ️🦵",
    "answers": "The Shawshank Redemption; The Shaw Shank Redemption; Shawshank Redemption; Shaw Shank Redemption",
    "hint1": "Plot Device: ⛏♟",
    "hint2": "Actor: Morgan Freeman",
    "answerDescription": "A man is wrongfully imprisoned and forms a friendship with another inmate.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://pressplaynews.files.wordpress.com/2021/10/shawshank.jpeg?w=1200",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-25"
  },
  {
    "prompt": "🎤🤒🇯🇴",
    "answers": "Michael Jordan",
    "hint1": "Sport: 🏀",
    "hint2": "Team: 🐥⚙️🅾️🐂🐂",
    "answerDescription": "Professional basketball player widely considered one of the greatest having won 6 titles with the Chicago Bulls.",
    "category": "Athlete",
    "rating": "",
    "imageUrl": "https://www.yardbarker.com/media/d/9/d9e35e1fba3d317eb7a4c3bb926a029c79dcd2e9/thumb_16x9/michael-jordan-career-retrospective.jpg",
    "submittedBy": "Brooke",
    "releaseDate": "2023-01-26"
  },
  {
    "prompt": "🥅🖕🖕",
    "answers": "Netflix; Netflicks",
    "hint1": "Category: 📼🏞",
    "hint2": "Product: 💿📬",
    "answerDescription": "Netflix was founded in 1997 by Reed Hastings & Marc Randolph on the idea that DVDs could be mailed to consumers.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://deadline.com/wp-content/uploads/2020/07/netflix-logo.png?w=681&h=313&crop=1",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-27"
  },
  {
    "prompt": "🦁🧙‍♀️💣👘",
    "answers": "The Lion, the Witch and the Wardrobe; The Lion, Witch, and the Wardrobe; The Lion, The Witch, and the Wardrobe; The Lion The Witch and the Wardrobe; Lion, Witch, and the Wardrobe; The Lion, The Witch, & The Wardrobe; The Lion The Witch and the Wardrobe; Lion, Witch and the Wardrobe; The Lion, The Witch & The Wardrobe; The Chronicles of Narnia; Narnia; Lion, Witch, and Wardrobe; Lion, Witch & Wardrobe",
    "hint1": "Published in 1950",
    "hint2": "Author: C.S. Lewis",
    "answerDescription": "Four siblings discover a magical wardrobe that leads them to the fantastical land of Narnia.",
    "category": "Book",
    "rating": "",
    "imageUrl": "https://whatsondisneyplus.com/wp-content/uploads/2020/04/The-Chronicles-of-Narnia-The-Lion-the-Witch-and-the-Wardrobe-e1586348295629-1024x576.png",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-28"
  },
  {
    "prompt": "🇬🇧🌞✋🏻",
    "answers": "The Jackson 5; The Jackson Five; Jackson 5; Jackson Five",
    "hint1": "Group founded in 1964 in Gary, Indiana",
    "hint2": "Song: 🔤",
    "answerDescription": "An American pop and soul group featuring the five Jackson siblings, including a young Michael Jackson. They were known for their soulful vocals and energetic stage performances.",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://images.genius.com/2dc88c6e1ad7c45a366dc85c6d377afb.1000x661x1.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-01-29"
  },
  {
    "prompt": "🍑🪟",
    "answers": "Rear Window; The Rear Window",
    "hint1": "Released in 1954",
    "hint2": "Directed by Alfred Hitchcock",
    "answerDescription": "A thriller about a man confined to his apartment with a broken leg who begins suspecting his neighbor has committed a murder.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://25yearslatersite.com/wp-content/uploads/2018/12/RearWindow-e1571615376987.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-01-30"
  },
  {
    "prompt": "🔑🏓⬆️🚗🏃‍♂️🙋🏻‍♀️💴",
    "answers": "Keeping Up with the Kardashians; Keep up with the Kardashians; Keeping up with the Cardashians; Keeping up with the Kardasheans",
    "hint1": "Genre: Reality TV",
    "hint2": "🧑🏻👱🏼‍♀️👩🏻👩🏻👱🏼‍♀️👩🏻",
    "answerDescription": "A reality TV series following the lives of the Kardashian-Jenner family.",
    "category": "TV Show",
    "rating": "",
    "imageUrl": "https://imageio.forbes.com/specials-images/imageserve/5f5845151992cda670ba8e2d/kuwtk/960x0.jpg?format=jpg&width=960",
    "submittedBy": "Sammie",
    "releaseDate": "2023-01-31"
  },
  {
    "prompt": "🧸👧🪡",
    "answers": "Ted Lasso",
    "hint1": "Plot: 🇺🇸🏈🔀🇬🇧⚽️",
    "hint2": "Actor: Jason Sudeikis",
    "answerDescription": "An American football coach is hired to coach a professional soccer team in England, despite having no experience with the sport.",
    "category": "TV Show",
    "rating": "",
    "imageUrl": "https://s3.amazonaws.com/thumbnails.thecrimson.com/photos/2021/10/04/213854_1351804.jpg.1500x843_q95_crop-smart_upscale.jpg",
    "submittedBy": "Lee Threadgill",
    "releaseDate": "2023-02-01"
  },
  {
    "prompt": "☕🐗🌅",
    "answers": "Groundhog Day; Ground Hog Day",
    "hint1": "Plot: 📆🔂",
    "hint2": "Actor: Bill Murray",
    "answerDescription": "A comedy film about a weatherman who is forced to relive the same day over and over again until he learns to become a better person.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://static1.colliderimages.com/wordpress/wp-content/uploads/2022/02/groundhog-day.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-02-02"
  },
  {
    "prompt": "🥶🎮",
    "answers": "Coldplay",
    "hint1": "Song: 💛⭐️🌻🌙🐝🍌",
    "hint2": "British rock band formed in London in 1997",
    "answerDescription": "British rock band formed in 1997, known for their emotive, melodic sound and hits such as \"Yellow,\" \"Fix You,\" and \"Viva La Vida.\"",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://www.nme.com/wp-content/uploads/2016/09/2016ColdplayGettyImages85353994_270116-1-696x462.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-02-03"
  },
  {
    "prompt": "➕💓🌶️",
    "answers": "Some Like It Hot",
    "hint1": "Released in 1959",
    "hint2": "Starring Marilyn Monroe",
    "answerDescription": "Two musicians go on the run, disguising themselves as women to join an all-female band.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://boredanddangerousblog.files.wordpress.com/2015/09/somelikeithot_poster.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-02-04"
  },
  {
    "prompt": "🍁✌🏻🦫",
    "answers": "Leave it to Beaver",
    "hint1": "Series ran from '57-'63",
    "hint2": "Remade into a movie in 1997",
    "answerDescription": "A sitcom about a young boy named Theodore \"Beaver\" Cleaver and his family living in a suburban neighborhood in the 1950s.",
    "category": "TV Show",
    "rating": "",
    "imageUrl": "https://imageservice.disco.peacocktv.com/uuid/49c9c680-f7d3-389e-b260-e3bbe5f67240/LAND_16_9?language=eng&territory=US&proposition=NBCUOTT&version=6f633167-550a-36cb-812c-63e92bc01563",
    "submittedBy": "Sammie",
    "releaseDate": "2023-02-05"
  },
  {
    "prompt": "🐇(🌾🚜)🦦",
    "answers": "Harry Potter",
    "hint1": "Plot device: ⚡️",
    "hint2": "Plot device: 🪄",
    "answerDescription": "A young orphan discovers he's a wizard and enrolls at Hogwarts where he must battle evil to save the wizarding world.",
    "category": "Book",
    "rating": "",
    "imageUrl": "https://blog.flipsnack.com/wp-content/uploads/2019/05/us_old2.jpg",
    "submittedBy": "Jessica Duddleston",
    "releaseDate": "2023-02-06"
  },
  {
    "prompt": "💤🪓🐝🐝",
    "answers": "Zaxby's; Zaxbys; Zaxbees; Zaxby; Zaxby’’s; Zaxby’s",
    "hint1": "Menu: 🍗🍟",
    "hint2": "Mascot: 🐓",
    "answerDescription": "A fast-food chain specializing in chicken fingers, wings, salads, and sandwiches.",
    "category": "Restaurant",
    "rating": "",
    "imageUrl": "https://www.zaxbys.com/uploads/Big_Zax_Snak_d22c5979ad.png",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-02-07"
  },
  {
    "prompt": "👩📑🐝🥰",
    "answers": "She Will Be Loved",
    "hint1": "Released in 2002",
    "hint2": "Song by Maroon 5",
    "answerDescription": "Pop rock ballad by Maroon 5, released in 2002.",
    "category": "Song",
    "rating": "",
    "imageUrl": "https://upload.wikimedia.org/wikipedia/en/1/1b/She_Will_be_Loved_cover.png",
    "submittedBy": "Sammie",
    "releaseDate": "2023-02-08"
  },
  {
    "prompt": "🚽👬🏻👂👂",
    "answers": "The Lumineers; Lumineers; The Luminears; Lumaneers; The Lumaneers",
    "hint1": "American alternative folk band based in Denver",
    "hint2": "Song: 🎅🏻👋🏻",
    "answerDescription": "An American folk rock band known for their energetic and upbeat style, and hits such as \"Ho Hey\" and \"Ophelia\".",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://www.loudhailermagazine.com/wp-content/uploads/2022/08/Header-TheLumineers-crypto.com-LosAngeles-CA-20220729-GOrtiz.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-02-09"
  },
  {
    "prompt": "🥛🎖️🧥",
    "answers": "Full Metal Jacket; Full Medal Jacket",
    "hint1": "🇻🇳🚁💣",
    "hint2": "Stanley Kubrick (1987)",
    "answerDescription": "A war film about a group of Marines who are trained for combat and then sent to fight in the Vietnam War.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://hbomax-images.warnermediacdn.com/images/GXdu2cQzfysPCwwEAADXM/tileburnedin?size=1280x720&partner=hbomaxcom&v=bd362c5dfbfd7e4585ff3f436772f2f4&host=art-gallery.api.hbo.com&language=en-us&w=1280",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-02-10"
  },
  {
    "prompt": "🫒®️🌪️",
    "answers": "Oliver Twist",
    "hint1": "Published in 1838",
    "hint2": "Author: Charles Dickens",
    "answerDescription": "The story of an orphan boy named Oliver Twist who navigates life in 19th-century England and its criminal underworld",
    "category": "Book",
    "rating": "",
    "imageUrl": "https://etc.usf.edu/lit2go/static/ogimages/books/50.jpg",
    "submittedBy": "Tyler Fuller",
    "releaseDate": "2023-02-11"
  },
  {
    "prompt": "🚄👀",
    "answers": "Trainspotting; Train Spotting",
    "hint1": "Released in1996",
    "hint2": "British cult classic",
    "answerDescription": "A black comedy film about a group of heroin addicts in Edinburgh, Scotland and the impact of their drug use on their lives and relationships.",
    "category": "Movie",
    "rating": "8.2",
    "imageUrl": "https://www.shortlist.com/media/images/2021/02/trainspotting4-1614077305-Idzc-column-width-inline.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-02-12"
  },
  {
    "prompt": "⏪🛣️👦🏻👦🏻",
    "answers": "Backstreet Boys; The Backstreet Boys",
    "hint1": "Vocal group formed in 1993",
    "hint2": "Received 9 Grammy nominations",
    "answerDescription": "An American boy band formed in 1993, known for their catchy pop harmonies and hits such as \"I Want It That Way\"",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://los40.com/los40/imagenes/2022/10/11/los40classic/1665499081_327712_1665499572_gigante_normal.jpg",
    "submittedBy": "Brooke",
    "releaseDate": "2023-02-13"
  },
  {
    "prompt": "🐟🐠🐟🪨",
    "answers": "School of Rock; The School of Rock",
    "hint1": "Directed by Richard Linklater",
    "hint2": "Actor: Jack Black",
    "answerDescription": "A wannabe rock star takes a job as a substitute teacher at an uptight private school, and turns his class into a rock band.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://sumo.cdn.tv2.no/imageapi/v3/img/6062edbd498e1ee1a5b45fbd-1641469879511",
    "submittedBy": "Brooke",
    "releaseDate": "2023-02-14"
  },
  {
    "prompt": "🍔⤵️🎲🎲",
    "answers": "Cheeseburger in Paradise",
    "hint1": "Released in 1978",
    "hint2": "Artist’s Last Name: 🥞🍇🍗🍖🍤🍩🍪",
    "answerDescription": "An upbeat island-style song by Jimmy Buffett released in 1978.",
    "category": "Song",
    "rating": "",
    "imageUrl": "https://groovyhistory.com/content/143616/d29f045d49aa062165c00bbfe71516a2.jpg",
    "submittedBy": "Brooke",
    "releaseDate": "2023-02-15"
  },
  {
    "prompt": "🕯🕯🕯🕯🕯🕯🕯🕯🕯🕯🕯🕯🕯🕯🕯🕯",
    "answers": "Sixteen Candles; 16 Candles",
    "hint1": "Released in 1984",
    "hint2": "Stars Molly Ringwald, Michael Schoeffling, and Anthony Michael Hall",
    "answerDescription": "A high school girl struggles to deal with the stress of her birthday being forgotten by her family and friends, as well as a crush on a popular senior.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://shatpod.com/movies/wp-content/uploads/Sixteen-Candles-Movie-Poster-1984.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-02-16"
  },
  {
    "prompt": "🛏️🛁🐝🔛",
    "answers": "Bed Bath & Beyond; Bed Bath and Beyond; Bed, Bath, and Beyond; bed bath beyond; Bed, bath and beyond; bed, bath & beyond",
    "hint1": "Big-box retailer on the verge of bankruptcy",
    "hint2": "Product category: home goods",
    "answerDescription": "A retail chain selling home goods, including bedding, bath towels, kitchen electrics, and storage solutions.",
    "category": "Retailer",
    "rating": "",
    "imageUrl": "https://b3h2.scene7.com/is/image/BedBathandBeyond/eer-store-image3xjpg?$content$&wid=1280",
    "submittedBy": "Renee LaBarge",
    "releaseDate": "2023-02-17"
  },
  {
    "prompt": "🥊🍻😍",
    "answers": "Punch-Drunk Love; Punch Drunk Love",
    "hint1": "Directed by Paul Thomas Anderson",
    "hint2": "Starring Adam Sandler",
    "answerDescription": "A lonely and emotionally stunted small business owner enters into a newfound relationship with a mysterious woman, leading to love and chaos.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://images.squarespace-cdn.com/content/v1/5a7dcf69d7bdce185884a6b5/1564637888054-Q16J3A831ZMV825TUWTC/d937e-vlcsnap-error050.png?format=1000w",
    "submittedBy": "Andrew Roche",
    "releaseDate": "2023-02-18"
  },
  {
    "prompt": "🏕️🔔🔔🍜",
    "answers": "Campbell's Soup; Campbells Soup; Campbell's; Campbels; Campbells; Campbell’s Soup; Campbell’s",
    "hint1": "Founded in 1869",
    "hint2": "Revenue: $8.7 billion",
    "answerDescription": "A well-known brand producing canned soups, sauces, and beverages.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://hips.hearstapps.com/hmg-prod/images/cans-of-campbells-soup-sit-on-a-shelf-in-a-grocery-store-on-news-photo-1046599136-1542810801.jpg",
    "submittedBy": "Renee LaBarge",
    "releaseDate": "2023-02-19"
  },
  {
    "prompt": "💔🤴😈",
    "answers": "Breaking Bad",
    "hint1": "Protagonist: 👨‍🏫",
    "hint2": "Plot Device: 💎🚬",
    "answerDescription": "A high school chemistry teacher transforms into a methamphetamine producer and dealer after being diagnosed with cancer.",
    "category": "TV Show",
    "rating": "",
    "imageUrl": "https://image-renderer.sinclairstoryline.com/prod/image-renderer/16x9/full/1050/center/80/9db1a729-eafc-47c7-958c-6e793dd091ad-large16x9_S113269640.JPG",
    "submittedBy": "Michael",
    "releaseDate": "2023-02-20"
  },
  {
    "prompt": "🫖🔩⚱️👩🏽",
    "answers": "Tina Turner",
    "hint1": "Queen of Rock 'n' Roll",
    "hint2": "Won 12 Grammys between '85-'08",
    "answerDescription": "An American-born singer & dancer known for her powerful voice and electrifying stage presence with hits such as \"What's Love Got to Do with It.\"",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://www.gannett-cdn.com/presto/2021/03/22/USAT/d1e90785-83b0-46ee-bee5-6b797d6f49bc-tina-turner-performs-live-on-stage-at-wembley-stadium-in-london-1990-_1.jpg?crop=1351,760,x0,y146&width=1351&height=760&format=pjpg&auto=webp",
    "submittedBy": "Renee LaBarge",
    "releaseDate": "2023-02-21"
  },
  {
    "prompt": "🏡◻️",
    "answers": "Casablanca; Casa Blanca",
    "hint1": "Released in 1942",
    "hint2": "Stars Humphrey Bogart",
    "answerDescription": "An American expat becomes torn between his love for a former flame and helping her and her husband escape from the Nazis.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://m.media-amazon.com/images/I/71A-sSmwjfL._AC_SL1414_.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-02-22"
  },
  {
    "prompt": "👀⚖️✌️😇",
    "answers": "Stairway to Heaven",
    "hint1": "Released in 1971",
    "hint2": "Genre: Rock",
    "answerDescription": "Song by English rock band Led Zeppelin, released in late 1971.",
    "category": "Song",
    "rating": "",
    "imageUrl": "https://www.digitalmusicnews.com/wp-content/uploads/2019/06/stairway_to_heaven_750400.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-02-23"
  },
  {
    "prompt": "⚖️🚿🇸🇦",
    "answers": "Lawrence of Arabia; Lawerence of Arabia",
    "hint1": "Released in 1962",
    "hint2": "Won 7 Oscars",
    "answerDescription": "The story of British officer T.E. Lawrence and his role in the Arab Revolt against the Ottoman Empire during World War I.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://sothebys-md.brightspotcdn.com/dims4/default/11c7596/2147483647/strip/true/crop/2000x1564+0+0/resize/2048x1602!/quality/90/?url=http%3A%2F%2Fsothebys-brightspot.s3.amazonaws.com%2Fmedia-desk%2Fa3%2Fcd%2F62f76d1c45028668069b662d221c%2Fl22898-ccr8y-1.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-02-24"
  },
  {
    "prompt": "🐝🧙",
    "answers": "Bewitched; Beewitched; Bewitch",
    "hint1": "Released from 1964-1972",
    "hint2": "Starring Elizabeth Montgomery & Dick York",
    "answerDescription": "A witch tries to live a normal life as a housewife, but her magical powers cause chaos for her and her husband.",
    "category": "TV Show",
    "rating": "",
    "imageUrl": "https://www.boomermagazine.com/wp-content/uploads/2021/09/bewitched-icon-800x450.jpg",
    "submittedBy": "Lee Threadgill",
    "releaseDate": "2023-02-25"
  },
  {
    "prompt": "👁❤️🚽👀",
    "answers": "I Love Lucy",
    "hint1": "Released from 1951-1957",
    "hint2": "Starring Lucille Ball & Des Arnaz",
    "answerDescription": "A classic sitcom about the comedic misadventures of a zany housewife and her Cuban bandleader husband.",
    "category": "TV Show",
    "rating": "",
    "imageUrl": "https://weird2ndhandfinds.com/wp-content/uploads/2023/01/1-50.png",
    "submittedBy": "Sammie",
    "releaseDate": "2023-02-26"
  },
  {
    "prompt": "⚓️🧔🏻‍♂️",
    "answers": "Anchorman; Anchorman: The Legend of Ron Burgundy; Anchorman the Legend of Ron Burgundy; Anchor Man",
    "hint1": "Comedy released in 2004",
    "hint2": "Starring Will Ferrell, Paul Rudd, Steve Carrell",
    "answerDescription": "A 1970s news anchor and his colleagues must adapt to the changing landscape of their industry.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://s29288.pcdn.co/wp-content/uploads/2019/05/anchorman-poster.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-02-27"
  },
  {
    "prompt": "🧑‍🤝‍🧑🫖🏌️‍♀️",
    "answers": "24; Twenty Four; Twenty-Four",
    "hint1": "Released from 2001-2010",
    "hint2": "Starring Kiefer Sutherland",
    "answerDescription": "Counter-terrorism agent Jack Bauer must race against the clock to prevent catastrophic events.",
    "category": "TV Show",
    "rating": "",
    "imageUrl": "https://static1.srcdn.com/wordpress/wp-content/uploads/2021/09/Featured-24-To-Return-On-Fox.jpg",
    "submittedBy": "Angela Yu",
    "releaseDate": "2023-02-28"
  },
  {
    "prompt": "🙂🛎🦵🚜",
    "answers": "Finding Nemo",
    "hint1": "Released in 2003 by Pixar",
    "hint2": "Starring Albert Brooks, Ellen DeGeneres",
    "answerDescription": "A clownfish must rescue his son after he is taken from the ocean and put in a fish tank.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/A6B8580D6192BB96B408A8CFFC1A338B933FBC446A10B56349DE7F9CB51C4EDE/scale?width=1200&aspectRatio=1.78&format=jpeg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-03-01"
  },
  {
    "prompt": "😡🅰️⛽️🚗",
    "answers": "Madagascar",
    "hint1": "Released in 2005 by DreamWorks",
    "hint2": "Starring Chris Rock, Ben Stiller, David Schwimmer",
    "answerDescription": "A group of animals end up on a wild adventure after escaping from their enclosure.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://ntvb.tmsimg.com/assets/p87313_v_h8_ad.jpg?w=1280&h=720",
    "submittedBy": "Jennifer Chou",
    "releaseDate": "2023-03-02"
  },
  {
    "prompt": "🇫🇷👨‍👩‍👧‍👦🍺",
    "answers": "Frankenstein; Frankenstine",
    "hint1": "Written in 1818",
    "hint2": "Authored by Mary Shelley",
    "answerDescription": "A scientist makes a creature from reanimated body parts, leading to moral dilemma.",
    "category": "Book",
    "rating": "",
    "imageUrl": "https://recollections.biz/blog/wp-content/uploads/2018/10/mary-shelley-featured-image-800.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-03-03"
  },
  {
    "prompt": "⬆️🌆👧🏼",
    "answers": "Uptown Girl",
    "hint1": "Released in 1983",
    "hint2": "Sung by Billy Joel",
    "answerDescription": "A song about a man from a working-class background who falls in love with a woman from a wealthy family.",
    "category": "Song",
    "rating": "",
    "imageUrl": "https://i.ebayimg.com/images/g/WicAAOSwgHhiJqFO/s-l400.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-03-04"
  },
  {
    "prompt": "⬇️🏘🆎🐝",
    "answers": "Downton Abbey; Downtown Abbey; Downton Abby; Downtown Abbey",
    "hint1": "Released from 2010-2015",
    "hint2": "Set in Britain in the early 20th century",
    "answerDescription": "A series that chronicles the lives of an aristocratic British family and their servants in the early 20th century.",
    "category": "TV Show",
    "rating": "",
    "imageUrl": "https://media.nu.nl/m/m1oxg3xa5qfi_wd1280/downton-abbey-wordt-film-met-originele-cast.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-03-05"
  },
  {
    "prompt": "🔴🔥🌶️🌶️",
    "answers": "Red Hot Chili Peppers; The Red Hot Chili Peppers; Red Hot Chilli Peppers; The Red Hot Chilli Peppers",
    "hint1": "Genre: Rock",
    "hint2": "Formed in Los Angeles in 1982",
    "answerDescription": "Alternative rock band known for their energetic, funk-infused sound and hits such as \"Scar Tissue\" and \"Californication.\"",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://c4.wallpaperflare.com/wallpaper/777/305/167/band-music-red-hot-chili-peppers-wallpaper-preview.jpg",
    "submittedBy": "Harry F",
    "releaseDate": "2023-03-06"
  },
  {
    "prompt": "😴➖🌊📧🔨",
    "answers": "Sleepless in Seattle",
    "hint1": "Romantic comedy released in 1993",
    "hint2": "Starring Tom Hanks & Meg Ryan",
    "answerDescription": "A recently widowed man's young son calls into a radio talk show to find him a new partner.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://static1.colliderimages.com/wordpress/wp-content/uploads/2021/09/sleepless-in-seattle.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-03-07"
  },
  {
    "prompt": "🌹💡",
    "answers": "Bud Light; Bud Lite",
    "hint1": "Make it a __________",
    "hint2": "🍺🍺",
    "answerDescription": "A popular American beer brand known for its light and crisp taste, low calorie count, and humorous advertising campaigns.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://cdn.builder.io/api/v1/image/assets%2F960a6dd36e654833ab8dd7a073f1b70b%2Ffa8b7e158acb462a974f4edcc70790ed",
    "submittedBy": "Sammie",
    "releaseDate": "2023-03-08"
  },
  {
    "prompt": "📌⭕🔑⭕",
    "answers": "Pinocchio; Pinokeyo; Pinochio",
    "hint1": "Early Disney movie",
    "hint2": "🤥",
    "answerDescription": "A wooden puppet dreams of becoming a real boy but must learn to be truthful and brave first.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://img1.hotstarext.com/image/upload/f_auto,t_hcdl/sources/r1/cms/prod/4343/674343-h",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-03-09"
  },
  {
    "prompt": "👛🕴️😊",
    "answers": "The Pursuit of Happyness; The Pursuit of Happiness; Pursuit of Happyness; Pursuit of Happiness",
    "hint1": "2006 biographical drama",
    "hint2": "Starring Will Smith",
    "answerDescription": "The true story of Chris Gardner, a struggling salesman who becomes homeless with his young son and fights to turn his life around.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://ntvb.tmsimg.com/assets/p162523_v_h8_ag.jpg?w=1280&h=720",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-03-10"
  },
  {
    "prompt": "🅿️🔑👨‍🦯👨‍🦯",
    "answers": "Peaky Blinders",
    "hint1": "Set in Birmingham, England in 1919",
    "hint2": "Starring Cillian Murphy, Tom Hardy",
    "answerDescription": "The exploits of the Shelby crime family in Birmingham, England in the aftermath of World War I.",
    "category": "TV Show",
    "rating": "",
    "imageUrl": "https://static1.colliderimages.com/wordpress/wp-content/uploads/2022/02/Peaky-Blinders-Cast-and-Character-Guide.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-03-11"
  },
  {
    "prompt": "🔪🔪🎖️",
    "answers": "Blades of Glory",
    "hint1": "Sports comedy released in 2007",
    "hint2": "Starring Will Ferrell and Jon Heder",
    "answerDescription": "Two male figure skaters must team up after being banned from singles skating.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://material.asset.catchplay.com/PAR-IN-001-A0060/artworks/posters/PAR-IN-001-A0060-P704.jpg?hash=1656562421",
    "submittedBy": "Sammie",
    "releaseDate": "2023-03-12"
  },
  {
    "prompt": "🐦👀📌🦵",
    "answers": "JCPenney; JC Penny",
    "hint1": "First store opened in 1902",
    "hint2": "Headquartered in Plano, TX",
    "answerDescription": "An American department store chain that sells clothing, accessories, and home furnishings.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://placewise.imgix.net/images/api/retailhubjs/d0e5dd0f7bfba0b68c3a68555a821f0a.png",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-03-13"
  },
  {
    "prompt": "🚽🚽🍋",
    "answers": "Lululemon; Lululemon Athletica",
    "hint1": "Founded in 1998",
    "hint2": "Headquartered in Vancouver, BC",
    "answerDescription": "A Canadian athletic apparel company known for its stylish and high-quality yoga and workout clothing.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://images.ctfassets.net/l16b5usqno44/umb-media-36878/30f90ebca958295fc378f98cc9088b03/store-logo-lululemon.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-03-14"
  },
  {
    "prompt": "🚫🔔🧩🏆",
    "answers": "Nobel Peace Prize; Nobel Prize; The Nobel Peace Prize; The Nobel Prize",
    "hint1": "Annual award",
    "hint2": "Currently held by Ales Bialiatski",
    "answerDescription": "Award given to individuals that have made contributions to promoting peace and resolving conflicts.",
    "category": "Quote/Phrase",
    "rating": "",
    "imageUrl": "https://gdb.voanews.com/5AE9AE5E-030E-4B18-A581-061B7C6DE1B9_w1023_r1_s.jpg",
    "submittedBy": "Renee LaBarge",
    "releaseDate": "2023-03-15"
  },
  {
    "prompt": "🛬🐝🍀⌚️",
    "answers": "The Land Before Time; Land Before Time; A Land Before Time",
    "hint1": "Animated movie released in 1998",
    "hint2": "🦖",
    "answerDescription": "An orphaned dinosaur named Littlefoot embarks on a journey to reach the Great Valley.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://images.justwatch.com/backdrop/238523437/s640",
    "submittedBy": "Lis",
    "releaseDate": "2023-03-16"
  },
  {
    "prompt": "✅📌",
    "answers": "Tic Tac",
    "hint1": "Subsidiary of Ferrero",
    "hint2": "Breath mint",
    "answerDescription": "A small, flavored breath mint that freshens breath on the go.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://www.packagingstrategies.com/ext/resources/2022/01/11/Tic_Tac_Packaging_Featuring_Positive_Messages.jpg?1641926042",
    "submittedBy": "Renee LaBarge",
    "releaseDate": "2023-03-17"
  },
  {
    "prompt": "🧎💎",
    "answers": "Neil Diamond; Neal Diamond",
    "hint1": "Born in Brooklyn in 1941",
    "hint2": "Has ten #1 singles",
    "answerDescription": "An American singer-songwriter known for his hits like \"Sweet Caroline\" and \"Cracklin' Rosie.\"",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://deadline.com/wp-content/uploads/2021/04/1976-Neil-Diamond-Photographer-Danny-Gutierrez_Oakland.jpg?w=681&h=383&crop=1",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-03-18"
  },
  {
    "prompt": "🚽🦵💵",
    "answers": "Johnny Cash",
    "hint1": "Born in Arkansas in 1932",
    "hint2": "Genre: Country",
    "answerDescription": "An iconic singer-songwriter known for his deep, distinctive voice and hits like \"I Walk the Line\" and \"Ring of Fire.\"",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://www.billboard.com/wp-content/uploads/media/johnny-cash-bw-portrait-klm-billboard-1548.jpg?w=942&h=623&crop=1",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-03-19"
  },
  {
    "prompt": "🥶👨‍👩‍👧‍👦📈",
    "answers": "Birkenstock",
    "hint1": "Headquartered in Germany",
    "hint2": "🩴",
    "answerDescription": "A brand of comfortable, eco-friendly sandals and shoes known for their cork footbeds and distinctive design.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://www.shoegalleryonline.com/cms/shoegallerycms/assets/Image/Birkenstock%20Brand%20Banner.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-03-20"
  },
  {
    "prompt": "🏙️🧘🦯",
    "answers": "Citizen Kane",
    "hint1": "Released in 1941",
    "hint2": "Directed by Orson Welles",
    "answerDescription": "A film that tells the story of a wealthy newspaper tycoon and his mysterious life.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://i.ebayimg.com/images/g/jsAAAOSw2s1U0-7D/s-l500.jpg",
    "submittedBy": "Tclawson",
    "releaseDate": "2023-03-21"
  },
  {
    "prompt": "🪰🤴🏭",
    "answers": "Nat King Cole",
    "hint1": "Born in Alabama in 1919",
    "hint2": "Genre: Jazz",
    "answerDescription": "A legendary American jazz pianist and singer known for his smooth, velvety voice and hits like \"Unforgettable\" and \"Mona Lisa.\"",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://s3.amazonaws.com/allaboutjazz/photos/a_large/9470a989e378de40104568055eb6b51c.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-03-22"
  },
  {
    "prompt": "🎀👨🙋🏻‍♂️💴🎁🌆",
    "answers": "Bohemian Rhapsody; Bohemian Rapsody",
    "hint1": "Rock ballad released in 1971",
    "hint2": "Title of a 2018 movie about the artist",
    "answerDescription": "A song by Queen that is famous for its operatic style, unconventional structure, and memorable chorus.",
    "category": "Song",
    "rating": "",
    "imageUrl": "https://img.europapress.es/fotoweb/fotonoticia_20151031080532_1200.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-03-23"
  },
  {
    "prompt": "🐊🦻",
    "answers": "Gatorade; Gatoraid",
    "hint1": "Category: Beverages",
    "hint2": "Invented at the University of Florida",
    "answerDescription": "Before becoming the most popular sports drink, Gatorade was developed by researchers at the University of Florida to enhance the performance and recovery of student athletes",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://s.hdnux.com/photos/14/06/17/3171307/7/1200x0.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-03-24"
  },
  {
    "prompt": "🐪🫖💩🫖",
    "answers": "Humpty Dumpty",
    "hint1": "First published in 1797",
    "hint2": "🥚",
    "answerDescription": "A beloved nursery rhyme character falls and shatters, teaching a lesson about risk-taking.",
    "category": "Poem",
    "rating": "",
    "imageUrl": "https://www.historydefined.net/wp-content/uploads/2022/03/6-40.jpeg",
    "submittedBy": "Michael",
    "releaseDate": "2023-03-25"
  },
  {
    "prompt": "☀️📅🩸☀️📅",
    "answers": "Sunday Bloody Sunday; Sunday Blood Sunday",
    "hint1": "Released in 1983",
    "hint2": "About the events of a 1972 incident",
    "answerDescription": "A rock anthem that protests the violence and bloodshed in Northern Ireland",
    "category": "Song",
    "rating": "",
    "imageUrl": "https://u2kite.files.wordpress.com/2015/12/600820-213.jpg?w=940&h=481",
    "submittedBy": "Renee LaBarge",
    "releaseDate": "2023-03-26"
  },
  {
    "prompt": "🪢📧🍇",
    "answers": "The Brady Bunch; Brady Bunch",
    "hint1": "Aired from 1969 to 1974",
    "hint2": "🎵 \"Here's the story\"",
    "answerDescription": "A large, warm and wholesome blended family navigates everyday life.",
    "category": "TV Show",
    "rating": "",
    "imageUrl": "https://www.goldderby.com/wp-content/uploads/2019/09/The-Brady-Bunch.jpg?w=640",
    "submittedBy": "Renee LaBarge",
    "releaseDate": "2023-03-27"
  },
  {
    "prompt": "🎵📖",
    "answers": "The Notebook; Notebook",
    "hint1": "Released in 2004",
    "hint2": "Ryan Gosling, Rachel McAdams",
    "answerDescription": "A timeless romantic drama about a passionate love affair in 1940s South Carolina.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://ichef.bbci.co.uk/images/ic/640x360/p08phs5c.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-03-28"
  },
  {
    "prompt": "🐒🐅🙈🐉",
    "answers": "Crouching Tiger, Hidden Dragon; Crouching Tiger Hidden Dragon",
    "hint1": "Released in 2000",
    "hint2": "Michelle Yeoh, Chow Yun-Fat",
    "answerDescription": "A visually stunning martial arts epic set in ancient China.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://cultbox.co.uk/wp-content/uploads/2023/01/crouching-tiger-hidden-dragon.jpg",
    "submittedBy": "Tyler",
    "releaseDate": "2023-03-29"
  },
  {
    "prompt": "🐻🪨⭕💣🤰",
    "answers": "Barack Obama; Barrack Obama; Barak Obama; Barrack; Obama",
    "hint1": "🇺🇸",
    "hint2": "Ⓜ️🐚",
    "answerDescription": "44th President of the United States, serving from 2009 to 2017",
    "category": "Person",
    "rating": "",
    "imageUrl": "https://news.columbia.edu/sites/default/files/content/obama-columbia.png",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-03-30"
  },
  {
    "prompt": "📻🧑‍🦲",
    "answers": "Radiohead",
    "hint1": "English rock band",
    "hint2": "Formed in 1985",
    "answerDescription": "An experimental rock band known for their eclectic sound and introspective lyrics",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://pyxis.nymag.com/v1/imgs/045/fed/60966d175a6a6e653e21f0eeda4884dca3-27-radiohead-1993.rsocial.w1200.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-03-31"
  },
  {
    "prompt": "💍⭕⭐",
    "answers": "Ringo Starr",
    "hint1": "🥁",
    "hint2": "🪲",
    "answerDescription": "A beloved musician and former member of The Beatles who continues to perform and create music",
    "category": "📸 Celebrity",
    "rating": "",
    "imageUrl": "https://www.cartv.es/thumbs/990x750r/2020-11/ringo.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-01"
  },
  {
    "prompt": "❄️🐒🐒",
    "answers": "Arctic Monkeys; The Arctic Monkeys; Artic Monkeys; The Artic Monkeys",
    "hint1": "English rock band",
    "hint2": "Nominated for six Grammy Awards",
    "answerDescription": "A popular indie rock band from England known for their clever lyrics and infectious hooks",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://media.pitchfork.com/photos/6356c63f1d88da653656ff47/2:1/w_2560%2Cc_limit/Arctic-Monkeys.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-02"
  },
  {
    "prompt": "🚶🤴☠️",
    "answers": "The Walking Dead; Walking Dead",
    "hint1": "Ran from 2010-2022",
    "hint2": "Based on comic book series by Robert Kirkman",
    "answerDescription": "Survivors of a zombie apocalypse fight to stay alive and retain their humanity",
    "category": "TV Show",
    "rating": "",
    "imageUrl": "https://ntvb.tmsimg.com/assets/p8282918_b_h8_bn.jpg?w=960&h=540",
    "submittedBy": "Sammie",
    "releaseDate": "2023-04-03"
  },
  {
    "prompt": "🐅🪵🪵",
    "answers": "Tiger Woods",
    "hint1": "⛳",
    "hint2": "🏌️",
    "answerDescription": "A legendary golfer who has dominated the sport for many years and shattered records",
    "category": "Athlete",
    "rating": "",
    "imageUrl": "https://s.abcnews.com/images/Sports/tiger-4-ap-er-190414_hpMain_16x9_992.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-04"
  },
  {
    "prompt": "🔑🅰️🆕🪸🪸",
    "answers": "Keanu Reeves; Keanu Reefs; Keanu Reaves",
    "hint1": "Canadian actor",
    "hint2": "The Matrix, John Wick",
    "answerDescription": "A versatile actor known for his roles in action films and his philanthropic work",
    "category": "📸 Celebrity",
    "rating": "",
    "imageUrl": "https://hips.hearstapps.com/hmg-prod/images/photo-of-keanu-reeves-news-photo-1576621075.jpg?crop=0.840xw:0.603xh;0.103xw,0.0647xh&resize=1200:*",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-05"
  },
  {
    "prompt": "Ⓜ️🤰💡👨‍👩‍👦",
    "answers": "Emma Watson",
    "hint1": "English actress",
    "hint2": "🪄",
    "answerDescription": "An actress and activist best known for her role as Hermione in the Harry Potter film franchise",
    "category": "📸 Celebrity",
    "rating": "",
    "imageUrl": "http://static.demilked.com/wp-content/uploads/2019/11/5ddce0ae4b6e8-amma-watson-harry-potter-quill-note-5ddba30444b1c__700.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-06"
  },
  {
    "prompt": "💳ℹ️🐝",
    "answers": "Cardi B; Cardi Bee",
    "hint1": "American rapper",
    "hint2": "Married to 'Offset'",
    "answerDescription": "A rapper and singer who has become one of the biggest names in hip-hop",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://vtv1.mediacdn.vn/thumb_w/650/2020/11/20/160324cardibphanphaokhibidanmangchetrachvitangtuihermeschocongai2tuoi1-1605840314525975476246-crop-16058403246261438041816.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-07"
  },
  {
    "prompt": "🍺❌🪐",
    "answers": "Bruno Mars",
    "hint1": "American singer",
    "hint2": "Born Peter Gene Hernandez",
    "answerDescription": "A pop superstar known for his catchy songs and energetic live performances",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://img-www.tf-cdn.com/artist/10/bruno-mars.jpeg?_v=20220226132842&fit=crop&crop=faces%20entropy&w=880&h=440",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-08"
  },
  {
    "prompt": "🧛🗓️🔚",
    "answers": "Vampire Weekend",
    "hint1": "American rock band",
    "hint2": "Grammy Award for Best Alternative Music Album in 2014",
    "answerDescription": "An indie rock band known for their upbeat, preppy sound and clever lyrics",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://popgoesthecharts.files.wordpress.com/2013/03/vampireweekend.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-09"
  },
  {
    "prompt": "🪨🛬⭕🌷",
    "answers": "Orlando Bloom",
    "hint1": "English actor",
    "hint2": "Married to Katy Perry",
    "answerDescription": "An actor known for his roles in the Pirates of the Caribbean and Lord of the Rings franchises",
    "category": "📸 Celebrity",
    "rating": "",
    "imageUrl": "https://imageio.forbes.com/specials-images/imageserve/684968036/0x0.jpg?format=jpg&crop=4428,2491,x0,y145,safe&width=1200",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-10"
  },
  {
    "prompt": "⬜🦓",
    "answers": "The White Stripes; White Stripes",
    "hint1": "American rock band",
    "hint2": "Formed by Jack White & Meg White",
    "answerDescription": "A garage rock duo known for their raw energy and distinctive sound",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://media.npr.org/assets/img/2013/10/21/ws-elephant-press1-2-_wide-743832f95e9614f9d29d6b353ec7ae870dc89454-s1100-c50.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-11"
  },
  {
    "prompt": "🧾🐝🌉🌉",
    "answers": "Phoebe Bridgers; Phoebe Bridges",
    "hint1": "American singer-songwriter",
    "hint2": "Nominated for four Grammy Awards in 2021",
    "answerDescription": "A singer-songwriter known for her introspective lyrics and haunting melodies",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://media.pitchfork.com/photos/637645b46c02f5a4a818b6c3/16:9/w_1280,c_limit/Phoebe-Bridgers.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-12"
  },
  {
    "prompt": "🥃💴🌊🏔️",
    "answers": "Ryan Seacrest",
    "hint1": "🎤",
    "hint2": "Host of American Idol",
    "answerDescription": "A television host and radio personality who has hosted numerous shows, including American Idol.",
    "category": "📸 Celebrity",
    "rating": "",
    "imageUrl": "https://www.usmagazine.com/wp-content/uploads/2023/03/Ryan-Seacrest-Still-Loves-Hosting-American-Idol-After-Announcing-Live-Exit-Everybody-Enjoys-Everybody-1.jpg?w=1200&quality=86&strip=all",
    "submittedBy": "Sammie",
    "releaseDate": "2023-04-13"
  },
  {
    "prompt": "🍓➰➰",
    "answers": "Froot Loops; Fruit Loops",
    "hint1": "🥣",
    "hint2": "Mascot is a toucan",
    "answerDescription": "A brightly colored breakfast cereal known for its fruity flavor and fun, circular shape",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://www.frootloops.com/content/dam/NorthAmerica/froot-loops/images/refresh21/promo-original.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-04-14"
  },
  {
    "prompt": "⬆️😁",
    "answers": "The North Face; North Face",
    "hint1": "🧥",
    "hint2": "Headquartered in Denver",
    "answerDescription": "A popular outdoor clothing and equipment brand known for their durable and high-quality products",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://search.alpinstore.com/data/media/47/2023-01-01_13-52-06_the-north-face-logo-1966.png",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-15"
  },
  {
    "prompt": "🐑🎀🌾🌾🌾",
    "answers": "Lambeau Field",
    "hint1": "🏈",
    "hint2": "🧀",
    "answerDescription": "The historic stadium in Green Bay, WI that's home to the NFL's Green Bay Packers",
    "category": "Sports",
    "rating": "",
    "imageUrl": "https://ewscripps.brightspotcdn.com/dims4/default/5b108f5/2147483647/strip/true/crop/640x360+0+42/resize/1280x720!/quality/90/?url=https%3A%2F%2Fmediaassets.tmj4.com%2Fphoto%2F2017%2F06%2F08%2Flambeau%20field%20generic%20getty_1496943794497_60863996_ver1.0_640_480.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-04-16"
  },
  {
    "prompt": "🪄🍆",
    "answers": "Magic Johnson",
    "hint1": "🏀",
    "hint2": "Led the Lakers to 5 NBA Championships",
    "answerDescription": "A former professional basketball player and business mogul",
    "category": "Athlete",
    "rating": "",
    "imageUrl": "https://cdn.aarp.net/content/dam/aarp/entertainment/television/2022/04/1140-magic-johnson-lakers.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-17"
  },
  {
    "prompt": "🧁❄️❄️",
    "answers": "Frosted Flakes",
    "hint1": "🐅",
    "hint2": "\"They're great!\"",
    "answerDescription": "A popular breakfast cereal made of corn flakes coated in sugar, and known for its mascot, Tony the Tiger",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://crueltyfreereviews.com/wp-content/uploads/2022/04/are-frosted-flakes-vegan.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-04-18"
  },
  {
    "prompt": "🚪🏃‍♂️",
    "answers": "DoorDash",
    "hint1": "🥘",
    "hint2": "Founded in Palo Alto in 2013",
    "answerDescription": "A food delivery service that allows customers to order food from restaurants and have it delivered to their door",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://keyt.b-cdn.net/2020/03/doordash.png",
    "submittedBy": "Sammie",
    "releaseDate": "2023-04-19"
  },
  {
    "prompt": "🪨🌉",
    "answers": "Colgate",
    "hint1": "🪥",
    "hint2": "$17 billion in annual revenue",
    "answerDescription": "A brand of toothpaste and other oral hygiene products",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Colgate_logo_red.svg/1200px-Colgate_logo_red.svg.png",
    "submittedBy": "Sammie",
    "releaseDate": "2023-04-20"
  },
  {
    "prompt": "😎🦁",
    "answers": "Coolio; Cooleo; Coolleo",
    "hint1": "Genre: rap",
    "hint2": "Passed away in 2022",
    "answerDescription": "A rapper and actor known for hit song \"Gangsta's Paradise\" and his appearances in films and TV shows.",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://ichef.bbci.co.uk/news/976/cpsprodpb/ACB1/production/_126890244_coolio_getty.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-21"
  },
  {
    "prompt": "🐑🐗🧈🦵",
    "answers": "Lamborghini; lamborghini; lamborgini; lambo; lamborginee",
    "hint1": "🏎️",
    "hint2": "Italian manufacturer",
    "answerDescription": "A luxury sports car manufacturer known for their sleek and powerful vehicles",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://techcrunch.com/wp-content/uploads/2021/09/Huraca%CC%81n-STO-Group-1.jpg?w=940&h=465&crop=1",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-22"
  },
  {
    "prompt": "🎤🐟",
    "answers": "Mike Trout",
    "hint1": "⚾",
    "hint2": "👼",
    "answerDescription": "A professional baseball player known for his impressive hitting and fielding skills",
    "category": "Athlete",
    "rating": "",
    "imageUrl": "https://a.espncdn.com/photo/2021/0518/r855945_1296x729_16-9.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-04-23"
  },
  {
    "prompt": "🏨2️⃣🌫️🏒",
    "answers": "Into the Mystic; Into a mystic; into mystic",
    "hint1": "Written by 🚐🫴ℹ️👨‍👩‍👦",
    "hint2": "Released in 1970",
    "answerDescription": "A classic song by Van Morrison with soulful lyrics and a dreamy, atmospheric sound",
    "category": "Song",
    "rating": "",
    "imageUrl": "https://i.ytimg.com/vi/CQKVNkeyGpk/maxresdefault.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-04-24"
  },
  {
    "prompt": "👌🏻🫖🍐📧",
    "answers": "Katy Perry; Katie Perry",
    "hint1": "Married to Orlando Bloom",
    "hint2": "Most-followed woman on Twitter",
    "answerDescription": "A pop singer known for her catchy songs and extravagant performances",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://assets.teenvogue.com/photos/5583276ffb1995762be2d927/16:9/w_2560%2Cc_limit/entertainment-music-2014-09-katy-perry-main.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-25"
  },
  {
    "prompt": "🔴🐂",
    "answers": "Red Bull",
    "hint1": "🥤",
    "hint2": "Gives you wings",
    "answerDescription": "An energy drink, known for its distinct taste and iconic branding, that provides a boost of energy & alertness through a blend of caffeine, taurine, and B-group vitamins.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://wallpapercave.com/wp/KGhWpFp.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-04-26"
  },
  {
    "prompt": "🫵🚇",
    "answers": "YouTube",
    "hint1": "Founded in 2005 by Steve Chen, Chad Hurley, and Jawed Karim",
    "hint2": "2nd most visited website",
    "answerDescription": "Global online video sharing and social media platform headquartered in San Bruno, California",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://aeonlaw.com/wp-content/uploads/2018/02/new-youtube-logo-840x402-1.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-04-27"
  },
  {
    "prompt": "🎡🅱️🫵®️📅📴",
    "answers": "Ferris Bueller's Day Off; Ferriss Bueller's Day Off; Ferris Bueller’s Day Off; Ferriss Bueller’s Day Off; Ferris Buellers Day Off; Ferriss Buellers Day Off; Ferriss Bueller; Ferris Bueller",
    "hint1": "1986 American teen comedy film",
    "hint2": "Starring Matthew Broderick",
    "answerDescription": "A classic 1980s comedy about a high school student who fakes being sick to have an epic day off with his friends",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://www.rollingstone.com/wp-content/uploads/2018/06/ferris-bueller-99dd7706-9817-47e8-91a8-bfa7f2131cd0.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-28"
  },
  {
    "prompt": "🥂🫖🦶",
    "answers": "Tostitos; Tostito's; Tostito’s",
    "hint1": "Product by Frito-Lay",
    "hint2": "\"Bring the party\"",
    "answerDescription": "Tostitos is a brand of Frito-Lay that produces different tortilla chips and a range of accompanying dips.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://i.ytimg.com/vi/2S-5aO4iEkI/maxresdefault.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-29"
  },
  {
    "prompt": "🏖️🐂🔒",
    "answers": "Sandra Bullock",
    "hint1": "American actress",
    "hint2": "2009 Academy Award for Best Actress",
    "answerDescription": "An Academy Award-winning actress known for her roles in films like Speed and Gravity",
    "category": "📸 Celebrity",
    "rating": "",
    "imageUrl": "https://wallpapers.com/images/hd/sandra-bullock-red-tank-top-lyjd5hrr68rmtmc0.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-04-30"
  },
  {
    "prompt": "🎤🚣🍦",
    "answers": "Microsoft",
    "hint1": "Based in Seattle",
    "hint2": "🧾🌉🌉",
    "answerDescription": "A leading technology company renowned for its operating systems, software, and hardware products.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://blogs.microsoft.com/wp-content/uploads/prod/2012/08/8867.Microsoft_5F00_Logo_2D00_for_2D00_screen.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-05-01"
  },
  {
    "prompt": "🤐🔐",
    "answers": "Ziploc",
    "hint1": "🥪👜",
    "hint2": "SC Johnson product",
    "answerDescription": "Ziploc offers a range of resealable plastic bags for convenient storage and organization.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://ziploc-uc1.azureedge.net/-/media/Components/Ziploc/Redesign/USA-Image-Cuts/JPG/products-section/Freezer-Quart/bags-freezer-quart-US-hero-front-2X.png?rev=2b4cef0be6914ba99091c461bb54815c&as=true&h=1100&w=2340&la=en&hash=36246C11F5C7AB6167F9B4043F37912C",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-02"
  },
  {
    "prompt": "🧹⏭️",
    "answers": "Kleenex; Cleanex",
    "hint1": "🤧",
    "hint2": "Owned by Kimberly-Clark, introduced in 1924",
    "answerDescription": "Kleenex, a popular brand of facial tissue, provides soft, absorbent products for personal care.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://1000logos.net/wp-content/uploads/2020/04/Kleenex-Logo-1992.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-03"
  },
  {
    "prompt": "🤮🥶",
    "answers": "Uber",
    "hint1": "🚕",
    "hint2": "Founded by Kalanick and Camp",
    "answerDescription": "The ridesharing app founded by Travis Kalanick and Garrett Camp in 2009",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://d3i4yxtzktqr9n.cloudfront.net/uber-sites/f452c7aefd72a6f52b36705c8015464e.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-04"
  },
  {
    "prompt": "🙅🏻‍♂️🔑🙄",
    "answers": "Nokia",
    "hint1": "📱",
    "hint2": "🇫🇮",
    "answerDescription": "A Finnish telecommunications company known for its durable mobile phones and cutting-edge network solutions.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://helios-i.mashable.com/imagery/articles/00EV4eLAOpXGPQseU6AWKpb/hero-image.fill.size_1248x702.v1611616156.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-05"
  },
  {
    "prompt": "👩‍⚕️🫑",
    "answers": "Dr. Pepper; Doctor Pepper",
    "hint1": "🥤",
    "hint2": "Created by a pharmacist in Texas",
    "answerDescription": "Created by pharmacist Charles Alderton in Waco, Texas in 1885, making it the oldest major soft drink brand in the U.S.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://sporked.com/wp-content/uploads/2023/02/BEST_DR_PEPPER_FLAVORS_HEADER.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-06"
  },
  {
    "prompt": "🪡🦵",
    "answers": "Sony",
    "hint1": "🎧",
    "hint2": "Japanese conglomerate famous for electronics",
    "answerDescription": "Founded in 1946 by Akio Morita and Masaru Ibuka in Japan, Sony produced a rice cooker before evolving into a leader in electronics.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://www.aeri.com/mfr-logos/Sony_logo.png",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-07"
  },
  {
    "prompt": "🙋‍♀️🔑🙄",
    "answers": "IKEA",
    "hint1": "🪑🛏️🛋️🪞",
    "hint2": "🇸🇪",
    "answerDescription": "A Swedish furniture retailer offering affordable, stylish, and easy-to-assemble home furnishings.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Ikea_logo.svg/1024px-Ikea_logo.svg.png",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-08"
  },
  {
    "prompt": "🍗🅾️",
    "answers": "Lego",
    "hint1": "🧱",
    "hint2": "🇩🇰",
    "answerDescription": "A Danish company inspiring creativity with its iconic interlocking plastic bricks and building sets.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://global-uploads.webflow.com/5e157548d6f7910beea4e2d6/61e7cffa99cc528244f78003_lego-logo.png",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-09"
  },
  {
    "prompt": "🌁🗿",
    "answers": "Bridgestone",
    "hint1": "🛞🛞",
    "hint2": "🏌️‍♀️🏌🏿‍♂️",
    "answerDescription": "A global tire manufacturer with high-quality, reliable products.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://frotacia.com.br/wp-content/uploads/2018/01/bridgestone-beffr.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-10"
  },
  {
    "prompt": "📆🪶",
    "answers": "Dayquil; Dayquill",
    "hint1": "🤒",
    "hint2": "💊💊",
    "answerDescription": "An over-the-counter cold and flu medicine providing daytime relief from various symptoms",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://images.ctfassets.net/xuuihvmvy6c9/6SNWbhLzflkDBwcaXyo5ok/ec069cd534882b134558a84111a7e734/New_Project__21_.png",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-11"
  },
  {
    "prompt": "⚫️🫐",
    "answers": "BlackBerry",
    "hint1": "📱",
    "hint2": "🇨🇦",
    "answerDescription": "Once a pioneer in smartphones, BlackBerry now focuses on cybersecurity and enterprise software solutions.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://e3.365dm.com/22/01/2048x1152/skynews-blackberry-phone_5632117.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-12"
  },
  {
    "prompt": "👴🏻🕵🏻‍♂️🧊",
    "answers": "Old Spice",
    "hint1": "\"If your grandfather hadn't worn it, you wouldn't exist.",
    "hint2": "Launched by soap and toiletry company Shulton Inc., in 1937.",
    "answerDescription": "Old Spice offers a range of products, including antiperspirant, deodorant, body wash, hair and beard care.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://i.ebayimg.com/images/g/9pQAAOSwVqJji4fb/s-l1600.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-13"
  },
  {
    "prompt": "🕳️🍇🥦🧀🍞",
    "answers": "Whole Foods; Hole Foods",
    "hint1": "Acquired by Amazon for $14 billion",
    "hint2": "Headquartered in Austin, TX",
    "answerDescription": "Supermarket chain headquartered in Austin, Texas, which sells products free from hydrogenated fats and artificial colors, flavors, and preservatives",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://m.media-amazon.com/images/S/assets.wholefoodsmarket.com/content/b5/68/d0e7dfed477d8afdb7234aeaab11/wfm-og-homepage-rectangle.png",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-14"
  },
  {
    "prompt": "🚐💂‍♂️",
    "answers": "Vanguard",
    "hint1": "🏦📈",
    "hint2": "Investment advisor based in Malvern, PA",
    "answerDescription": "Registered investment advisor based in Malvern, Pennsylvania, with about $8 trillion in global assets under management",
    "category": "🏢 Company",
    "rating": "",
    "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSSTTU-TfPo54TwSwCUR6CotSMtytDu5E467g&usqp=CAU",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-15"
  },
  {
    "prompt": "👨🌌",
    "answers": "Headspace",
    "hint1": "🟠",
    "hint2": "🧘‍♂️",
    "answerDescription": "A guided meditation and mindfulness app founded by Andy Puddicombe",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://tukuz.com/wp-content/uploads/2019/11/headspace-inc-logo-vector.png",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-16"
  },
  {
    "prompt": "🚐🚐",
    "answers": "Vans",
    "hint1": "👟👟",
    "hint2": "🛹",
    "answerDescription": "Manufacturer of skateboarding shoes and related apparel, established in Anaheim, CA in 1966",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://1000logos.net/wp-content/uploads/2017/06/Vans-logo.png",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-17"
  },
  {
    "prompt": "🔗🔟",
    "answers": "LinkedIn",
    "hint1": "💼👨‍💼👩‍💼",
    "hint2": "Founded by Reid Hoffman",
    "answerDescription": "A business and employment-focused social media platform that launched in 2003 and is now owned by Microsoft",
    "category": "🏢 Company",
    "rating": "",
    "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/LinkedIn_Logo.svg/2560px-LinkedIn_Logo.svg.png",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-18"
  },
  {
    "prompt": "💨🐝➕🐝",
    "answers": "Airbnb",
    "hint1": "🏠",
    "hint2": "Founded by Chesky, Gebbia, and Blecharczyk",
    "answerDescription": "San Francisco-based company operating an online marketplace for short- and long-term homestays and experiences",
    "category": "🏢 Company",
    "rating": "",
    "imageUrl": "https://www.digital.ink/wp-content/uploads/airbnb_logo_detail.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-19"
  },
  {
    "prompt": "🍫🐝",
    "answers": "Barbie; Barbie Movie; The Barbie Movie",
    "hint1": "🪆",
    "hint2": "Margot Robbie, Ryan Gosling",
    "answerDescription": "After being expelled from Barbieland for being a less than perfect-looking doll, Barbie sets off for the human world to find true happiness.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT_-MY3fWdu08WuXQYOMnjMlDZeoMtM2SnPjA&usqp=CAU",
    "submittedBy": "Lis",
    "releaseDate": "2023-05-20"
  },
  {
    "prompt": "👴🏻⛴️",
    "answers": "Old Navy",
    "hint1": "👖👖",
    "hint2": "Owned by Gap",
    "answerDescription": "Clothing and accessories retailing company founded in 1994 and owned by Gap Inc. with corporate operations in the Mission Bay neighborhood of San Francisco",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Old_Navy_Logo.svg/1200px-Old_Navy_Logo.svg.png",
    "submittedBy": "Sammie",
    "releaseDate": "2023-05-21"
  },
  {
    "prompt": "🇺🇸🗿",
    "answers": "American Idol",
    "hint1": "🎤",
    "hint2": "Hosted by Ryan Seacrest",
    "answerDescription": "Several participants from America showcase their singing talent in front of a panel of esteemed judges to win the title and a record label deal",
    "category": "TV Show",
    "rating": "",
    "imageUrl": "https://www.nickiswift.com/img/gallery/where-the-former-american-idol-judges-are-today/intro-1595326094.jpg",
    "submittedBy": "Angela Shylock",
    "releaseDate": "2023-05-22"
  },
  {
    "prompt": "🚗❤️",
    "answers": "Carhartt; Carheart; Carhart",
    "hint1": "👷‍♂️👕",
    "hint2": "Founded in Detroit in 1889",
    "answerDescription": "Apparel company founded in 1889, known for heavy-duty working clothes such as jackets, coats, and overalls",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://logos-world.net/wp-content/uploads/2021/08/Carhartt-Logo.png",
    "submittedBy": "Angela Shylock",
    "releaseDate": "2023-05-23"
  },
  {
    "prompt": "🦸‍♂️😴💭🍣",
    "answers": "Jiro Dreams of Sushi; Hero Dreams of Sushi",
    "hint1": "👨‍🍳🎌",
    "hint2": "2011 Japanese documentary",
    "answerDescription": "A documentary chronicling Jiro Ono, an 85-year-old owner of a three-star restaurant in Tokyo and his pursuit of perfection in the art of sushi.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://images-na.ssl-images-amazon.com/images/S/pv-target-images/6d3ac8e8ab9ff37cd40909fb4c66797f9bee4354265e50577e691d3d75082b84._UY500_UX667_RI_TTW_.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-24"
  },
  {
    "prompt": "🌭🌊",
    "answers": "Frank Ocean",
    "hint1": "2016 Album Blonde",
    "hint2": "Born 10/28/1987 in Long Beach, CA",
    "answerDescription": "A singer, songwriter, and rapper whose works are noted for featuring avant-garde styles and introspective, elliptical lyrics.",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://www.interfax.ru/ftproot/photos/photostory/2013/02/11/500gra8.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-05-25"
  },
  {
    "prompt": "🟩📆",
    "answers": "Green Day",
    "hint1": "Formed in East Bay, CA in '87",
    "hint2": "75 million records sold",
    "answerDescription": "Rock band formed in the East Bay of California in 1987 by Billie Joe Armstrong, Mike Dirnt, and (later) Tré Cool",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://consequence.net/wp-content/uploads/2016/09/green-day-90s.jpg?quality=80",
    "submittedBy": "Sammie",
    "releaseDate": "2023-05-26"
  },
  {
    "prompt": "🚪🍽️🦶",
    "answers": "Doritos",
    "hint1": "Snack",
    "hint2": "Frito-Lay",
    "answerDescription": "American brand of flavored tortilla chips produced by Frito-Lay. The first flavor was Toasted Corn, released in 1966, followed by Taco in 1967 and Nacho Cheese in 1972.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://www.eatthis.com/wp-content/uploads/sites/4/2021/06/doritos.jpg?quality=82&strip=1",
    "submittedBy": "Sammie",
    "releaseDate": "2023-05-27"
  },
  {
    "prompt": "🐜👔🦸🏼‍♀️",
    "answers": "Anti-Hero; Anti Hero",
    "hint1": "On Midnights (2022)",
    "hint2": "Taylor Swift",
    "answerDescription": "A song by singer-songwriter Taylor Swift and the lead single from her tenth studio album, Midnights (2022)",
    "category": "Song",
    "rating": "",
    "imageUrl": "https://media.pitchfork.com/photos/63528c4d2e50e6a7eeafe2db/2:1/w_2560%2Cc_limit/Taylor-Swift.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-05-28"
  },
  {
    "prompt": "🏝️🌊➕☀️🩹",
    "answers": "KC and The Sunshine Band; K. C. and The Sunshine Band; KC & The Sunshine Band; K. C. &The Sunshine Band",
    "hint1": "\"That's the Way\"",
    "hint2": "\"Shake Your Booty\"",
    "answerDescription": "Disco and funk band founded in 1973 in Hialeah, Florida. Their best-known songs include the hits \"That's the Way\" and \"Shake Your Booty\"",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://curiosando708090.altervista.org/wp-content/uploads/2012/01/KC+and+the+Sunshine+Band.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-05-29"
  },
  {
    "prompt": "🛣️💔😴💭😴💭",
    "answers": "Boulevard of Broken Dreams; Boulevard of Broken Dream",
    "hint1": "Written by Billie Joe Armstrong",
    "hint2": "Green Day",
    "answerDescription": "A song by rock band Green Day and fourth track from their seventh studio album American Idiot (2004).",
    "category": "Song",
    "rating": "",
    "imageUrl": "https://i.ytimg.com/vi/uphaXAKeZH4/maxresdefault.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-05-31"
  },
  {
    "prompt": "🥉👁️🧑‍🦯",
    "answers": "Third Eye Blind",
    "hint1": "\"Jumper\"",
    "hint2": "\"Semi-Charmed Life\"",
    "answerDescription": "Rock band formed in San Francisco, California, in 1993",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://www.billboard.com/wp-content/uploads/media/third-eye-blind-1997-billboard-1500.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-06-01"
  },
  {
    "prompt": "💔⏮️⛰️",
    "answers": "Brokeback Mountain; Brokeback Mtn",
    "hint1": "🤠🤠",
    "hint2": "👬",
    "answerDescription": "Rodeo cowboy Jack Twist and ranch hand Ennis Del Mar are hired by rancher Joe Aguirre as sheep herders in Wyoming.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://images1.resources.foxtel.com.au/store2/mount1/16/4/81hdf.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-06-04"
  },
  {
    "prompt": "😵🧾",
    "answers": "Kill Bill; Kill-Bill; Kill Bill",
    "hint1": "Director: Quentin Tarantino",
    "hint2": "Starring Uma Thurman",
    "answerDescription": "An action thriller directed by Quentin Tarantino, featuring Uma Thurman as a revenge-seeking former assassin.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://secure.franklintheatre.com/images/user/ft_11874/kill%20bill%201.jpg",
    "submittedBy": "Emil Narragon",
    "releaseDate": "2023-06-05"
  },
  {
    "prompt": "🎮🛑",
    "answers": "Game Stop; Games Stop",
    "hint1": "Retail store",
    "hint2": "Highly volatile stock price",
    "answerDescription": "A retail chain that sells video games, gaming hardware, and accessories, which gained attention in 2021 due major volatility of its stock price.",
    "category": "Brand",
    "rating": "",
    "imageUrl": "https://logos-world.net/wp-content/uploads/2021/03/GameStop-Logo.png",
    "submittedBy": "Angela Shylock",
    "releaseDate": "2023-06-06"
  },
  {
    "prompt": "🍷🦁🐬🐘",
    "answers": "Glass Animals",
    "hint1": "Song: Heat Waves (2B+ listens)",
    "hint2": "Formed in Oxford in 2010",
    "answerDescription": "An indie rock band known for their unique psychedelic pop sound, characterized by intricate, multi-layered music and deep, thoughtful lyrics.",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://www.nme.com/wp-content/uploads/2022/06/Glass-Animals-Sam-Keeler-1.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-06-07"
  },
  {
    "prompt": "⬆️🏘️🕺",
    "answers": "Uptown Funk",
    "hint1": "Released November 2014",
    "hint2": "Ronson, Mars",
    "answerDescription": "An infectious, chart-topping hit by Mark Ronson featuring Bruno Mars, blending funk, pop, and soul genres.",
    "category": "Song",
    "rating": "",
    "imageUrl": "https://static.onecms.io/wp-content/uploads/sites/6/2015/08/uptown-funk.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-06-08"
  },
  {
    "prompt": "😆🥇🍽️🫖✌️",
    "answers": "Blink-182; Blink 182",
    "hint1": "Pop punk band founded in '92",
    "hint2": "All The Small Things",
    "answerDescription": "Rock band formed in 1992 and made up of bassist/ vocalist Mark Hoppus, guitarist/ vocalist Tom DeLonge, and drummer Travis Barker.",
    "category": "🎵 Artist",
    "rating": "",
    "imageUrl": "https://jpimg.com.br/uploads/2019/09/blink-182-anos-90.jpg",
    "submittedBy": "Sammie",
    "releaseDate": "2023-06-09"
  },
  {
    "prompt": "🎲🪨",
    "answers": "Die Hard",
    "hint1": "Based on \"Nothing Lasts Forever\"",
    "hint2": "Bruce Willis",
    "answerDescription": "Die Hard is an American action film series that originated with Roderick Thorp's 1979 novel Nothing Lasts Forever.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://s29288.pcdn.co/wp-content/uploads/2010/09/die-hard-poster.jpg",
    "submittedBy": "Lis",
    "releaseDate": "2023-06-10"
  },
  {
    "prompt": "🚽🕯️",
    "answers": "John Wick; Jon Wick",
    "hint1": "Neo noir action thriller",
    "hint2": "Keanu Reeves",
    "answerDescription": "An action thriller centered around a former hitman who is forced back into the criminal underworld he had previously abandoned",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://wallpaperstock.net/john-wick-poster_wallpapers_46735_2560x1440.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-06-11"
  },
  {
    "prompt": "⛪️👨‍👧",
    "answers": "The Godfather; Godfather",
    "hint1": "Released in 1972",
    "hint2": "Won 3 Oscars",
    "answerDescription": "The Corleone family actively maneuvers through the treacherous landscape of organized crime and heartbreaking betrayals in post-World War II America.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://ntvb.tmsimg.com/assets/p6326_v_h8_be.jpg?w=1280&h=720",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-06-12"
  },
  {
    "prompt": "🍽️🙏🏻❤️",
    "answers": "Eat, Pray, Love; Eat Pray Love",
    "hint1": "Story by Elizabeth Gilbert",
    "hint2": "Julia Roberts",
    "answerDescription": "A married woman realizes how unhappy her marriage really is, and that her life needs to go in a different direction.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://occ-0-2219-33.1.nflxso.net/dnm/api/v6/6gmvu2hxdfnQ55LZZjyzYR4kzGk/AAAABYOXFAhAXFRpedFDR9sDBOwASR5oY4pGpoUmYcIgy5ZcVq4aMwibcOoE6DgTaPtO_oAcNNXQbFQULi_OAjhtt0HM_RG7eFYcMoWf.jpg?r=92d",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-06-13"
  },
  {
    "prompt": "🛟🥧",
    "answers": "Life of Pi; Life of Pie; The Life of Pi; The Life of Pie",
    "hint1": "⛴️",
    "hint2": "🐅",
    "answerDescription": "A young Indian boy named Pi survives a shipwreck and finds himself stranded on a lifeboat with a Bengal tiger, embarking on a remarkable journey of survival and self-discovery.",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://img1.hotstarext.com/image/upload/f_auto,t_web_m_1x/sources/r1/cms/prod/9554/919554-h",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-06-14"
  },
  {
    "prompt": "🏎️🤬",
    "answers": "The Fast and the Furious; Fast & Furious; fast and furious; the fast and furious",
    "hint1": "First of ten movies",
    "hint2": "Vin Diesel, Paul Walker",
    "answerDescription": "An LAPD officer goes undercover in the street racing world to investigate a group of unknown hijackers",
    "category": "Movie",
    "rating": "",
    "imageUrl": "https://metadata-static.plex.tv/c/gracenote/c01c0a991562c59614bf5ae3355855fc.jpg",
    "submittedBy": "Aubrey",
    "releaseDate": "2023-06-16"
  }
];

export function getPuzzleByDate(date) {
  return puzzles.find((p) => p.releaseDate === date) || null;
}

export function getArchivePuzzles(beforeDate) {
  return puzzles.filter((p) => p.releaseDate && p.releaseDate < beforeDate);
}

/** Remaining puzzles after a given date, oldest → newest. */
export function getPuzzlesAfterDate(afterDate) {
  return puzzles.filter((p) => p.releaseDate && p.releaseDate > afterDate);
}

export function getEarliestPuzzle() {
  return puzzles[0] || null;
}

export function getLatestPuzzle() {
  return puzzles[puzzles.length - 1] || null;
}
